import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { ColorRing } from 'react-loader-spinner';
import PageTitle from "../../../components/common/PageTitle";
import { toast } from 'react-toastify';
import FeatherIcon from 'feather-icons-react';
import {
  Badge,
  Button,
  ButtonGroup,
  Col, Row,
  Card, CardBody,
  InputGroup,
  InputGroupAddon,
  FormInput,
  FormSelect,
  FormCheckbox,
  FormTextarea,
  Modal,
  ModalHeader,
  ModalBody,
} from "shards-react";
import moment from "moment";
import {reactLocalStorage as Storage} from "reactjs-localstorage";

@inject(({ AOA }) => ({ getAllStoreList: AOA.getAllStoreList, getStoreDetail: AOA.getStoreDetail, csLogin: AOA.csLogin, unsubscribeUser: AOA.unsubscribeUser, withdrawal: AOA.withdrawal, sendMailTo: AOA.sendMailTo, updateStoresManualStatus: AOA.updateStoresManualStatus, renewToken: AOA.renewToken, permanentDeleteStore: AOA.permanentDeleteStore, getStoreDataCounts: AOA.getStoreDataCounts, setStoreManualUseExpiry: AOA.setStoreManualUseExpiry, sendTaxInvoiceRequest: AOA.sendTaxInvoiceRequest, adminChargeStoreMessages: AOA.adminChargeStoreMessages, setStoreSample: AOA.setStoreSample, grantReviewWriteAddonGrandfather: AOA.grantReviewWriteAddonGrandfather }))
@inject(({ company }) => ({ getApplySkins: company.getApplySkins }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))

@observer
class AllStoreList extends Component {

  @observable isLoading = true;
  @observable list = {};
  @observable listParams = {
    page: 1,
    limit: 30,
    sort: 'createdAt',
    searchParams: {}
  };
  @observable filter = 'all'; // all, active_paid, active_free, stopped_cancelled, stopped_inactive
  @observable toggledStores = {}; // 샵 토글 상태

  // 일괄 선택/상태 변경
  @observable selectedStoreIds = []; // 선택된 스토어 _id 배열
  @observable showStatusMenu = false; // 상태 변경 드롭다운 표시 여부

  // 토큰 갱신 진행 상태 (store._id 별)
  @observable renewingTokenIds = [];

  // 리뷰 부스터 애드온 — 기존 유료자 일괄 부여 (super-admin, 1회·멱등)
  @observable grandfatherCutoff = moment().format('YYYY-MM-DD');
  @observable grandfatherRunning = false;
  @observable grandfatherResult = null;

  runGrandfather = async () => {
    if (this.grandfatherRunning) return;
    if (!this.grandfatherCutoff) { toast.error('기준일을 입력해 주세요.'); return; }
    if (!window.confirm(`${this.grandfatherCutoff} 이전 가입 + 현재 유료 스토어에 '리뷰 부스터 애드온' 권한을 일괄 부여합니다.\n(멱등 — 이미 부여된 건 건너뜀)\n진행할까요?`)) return;
    this.grandfatherRunning = true;
    this.grandfatherResult = null;
    try {
      const cutoffIso = moment(this.grandfatherCutoff).endOf('day').toISOString();
      const res = await this.props.grantReviewWriteAddonGrandfather({ cutoffDate: cutoffIso });
      const d = (res && res.data) ? res.data : null;
      if (d && d.ok) {
        this.grandfatherResult = d;
        toast.success(`완료 — ${d.modified}개 스토어 부여 (대상 ${d.matched})`);
      } else {
        this.grandfatherResult = d || { ok: false, error: '권한 또는 응답 오류' };
        toast.error('실패: ' + ((d && d.error) || '권한 또는 응답 오류'));
      }
    } catch (e) {
      this.grandfatherResult = { ok: false, error: (e && e.message) || String(e) };
      toast.error('오류: ' + ((e && e.message) || e));
    } finally {
      this.grandfatherRunning = false;
    }
  };

  // 완전삭제 모달
  @observable permanentDeleteModal = {
    isOpen: false,
    isLoading: false,
    isDeleting: false,
    store: null,           // {_id, name, _withdrawal}
    counts: [],            // [{collection, count}]
    selectedCollections: [],
    confirmName: '',
  };

  // 전체 스킨 일괄 새로고침
  @observable bulkSkinRefresh = {
    isRunning: false,
    current: 0,
    total: 0,
    failed: 0,
    currentStoreName: '',
    cancelRequested: false,
    failedStores: [], // [{ name, platformId, shopNo, message }]
    showFailedModal: false,
  };

  // 스토어 상세 보기 모달
  @observable modals = {
    isStoreDetail: false,
    storeDetailData: {},
    shop: [],
    selectedShopNo: '',
    skins: [],
    skinShopNo: 1,
    isRefreshingSkins: false,
    withdrawalReason: '관리자 탈퇴 처리',
  };

  // 알림톡 충전 모달
  @observable msgChargeModal = {
    isOpen: false,
    isSaving: false,
    store: null,
    messageType: 'KAKAO',     // KAKAO | SMS
    chargeCount: '',          // 충전 건수
    chargeAmount: '',         // 충전 금액 (옵션)
    chargeCategory: 'event',  // bank_transfer | event | apology | compensation | etc
    memo: ''                  // 사유
  };

  // 통장입금 처리 모달
  @observable manualPayModal = {
    isOpen: false,
    isSaving: false,
    isSendingTaxInvoice: false,   // 세금계산서 발행 요청 메일 발송 중
    taxInvoiceSent: false,        // 발송 완료 표시
    store: null,                  // 대상 스토어 객체
    shopNo: '',                   // 선택한 샵 platformShopNo
    useExpiryDate: '',            // 종료일 (YYYY-MM-DD)
    startDate: '',                // 시작일 (YYYY-MM-DD)
    totalAmount: '',              // 입금 금액 (부가세 포함)
    bankTransferReason: '',       // 사유
    taxInvoiceIssued: false,      // 세금계산서 발행 여부
    taxInvoiceEmail: '',          // 세금계산서 이메일
    businessRegNumber: '',        // 사업자등록번호
  };

  validFilters = ['all', 'active_paid', 'active_free', 'stopped_cancelled', 'stopped_inactive', 'withdrawal', 'sample'];

  componentDidMount() {
    // URL 쿼리 파라미터에서 탭 상태 복원
    let params = new URLSearchParams(window.location.search);
    let urlFilter = params.get('status');
    let urlPage = parseInt(params.get('page'), 10);
    let urlKeyword = params.get('keyword');

    if (urlFilter && this.validFilters.indexOf(urlFilter) !== -1) {
      this.filter = urlFilter;
      if (urlFilter !== 'all') {
        this.listParams.searchParams.statusFilter = urlFilter;
      }
      // 구독취소 탭: 구독취소일(Shop.cancelledAt) 기준 정렬
      this.listParams.sort = urlFilter === 'stopped_cancelled' ? 'cancelledAt' : 'createdAt';
    }
    if (urlKeyword) {
      this.listParams.searchParams.keyword = urlKeyword;
    }
    if (urlPage && urlPage > 0) {
      this.listParams.page = urlPage;
    }

    this.getList();
  }

  syncUrl = () => {
    let params = new URLSearchParams();
    if (this.filter && this.filter !== 'all') params.set('status', this.filter);
    if (this.listParams.searchParams.keyword) params.set('keyword', this.listParams.searchParams.keyword);
    if (this.listParams.page && this.listParams.page > 1) params.set('page', this.listParams.page);
    let queryStr = params.toString();
    let newUrl = window.location.pathname + (queryStr ? '?' + queryStr : '');
    window.history.replaceState(null, '', newUrl);
  };

  @action getList = async () => {
    this.isLoading = true;
    this.syncUrl();
    let res = await this.props.getAllStoreList(this.listParams);
    if (res) {
      this.list = res;
    }
    this.isLoading = false;
  };

  @action onSearch = (e) => {
    e.preventDefault();
    let formData = new FormData(e.target);
    let keyword = formData.get('keyword');
    if (keyword) {
      this.listParams.searchParams.keyword = keyword;
    } else {
      delete this.listParams.searchParams.keyword;
    }
    this.listParams.page = 1;
    this.getList();
  };

  @action setFilter = (type) => {
    this.filter = type;
    this.listParams.page = 1;
    // 검색어는 유지하고 필터만 초기화
    let keyword = this.listParams.searchParams.keyword;
    this.listParams.searchParams = {};
    if (keyword) this.listParams.searchParams.keyword = keyword;

    if (type !== 'all') {
      this.listParams.searchParams.statusFilter = type;
    }

    // 탭별 기본 정렬: 구독취소 탭은 구독취소일(Shop.cancelledAt) 기준
    this.listParams.sort = type === 'stopped_cancelled' ? 'cancelledAt' : 'createdAt';

    // 탭 변경 시 선택 초기화
    this.selectedStoreIds = [];
    this.showStatusMenu = false;

    this.getList();
  };

  @action goPage = (page) => {
    this.listParams.page = page;
    // 페이지 변경 시 선택 초기화
    this.selectedStoreIds = [];
    this.showStatusMenu = false;
    this.getList();
  };

  componentWillUnmount() {
    // 상태 리셋 (다른 페이지 이동 시)
  }

  @action toggleShopDetail = (storeId) => {
    this.toggledStores[storeId] = !this.toggledStores[storeId];
  };

  // === 일괄 선택 메서드들 ===
  @action toggleSelect = (storeId) => {
    let idx = this.selectedStoreIds.indexOf(storeId);
    if (idx === -1) {
      this.selectedStoreIds.push(storeId);
    } else {
      this.selectedStoreIds.splice(idx, 1);
    }
  };

  @action toggleSelectAll = () => {
    let docs = (this.list && this.list.docs) || [];
    let selectableDocs = docs.filter(s => s && s._id); // _id 없는 행 제외
    if (this.isAllSelected()) {
      // 현재 페이지 항목들을 선택에서 제거
      selectableDocs.forEach(s => {
        let idx = this.selectedStoreIds.indexOf(s._id);
        if (idx !== -1) this.selectedStoreIds.splice(idx, 1);
      });
    } else {
      // 현재 페이지 모든 항목 선택
      selectableDocs.forEach(s => {
        if (this.selectedStoreIds.indexOf(s._id) === -1) {
          this.selectedStoreIds.push(s._id);
        }
      });
    }
  };

  isAllSelected = () => {
    let docs = (this.list && this.list.docs) || [];
    let selectableDocs = docs.filter(s => s && s._id);
    if (selectableDocs.length === 0) return false;
    return selectableDocs.every(s => this.selectedStoreIds.indexOf(s._id) !== -1);
  };

  @action clearSelection = () => {
    this.selectedStoreIds = [];
    this.showStatusMenu = false;
  };

  @action bulkUpdateStatus = async (status) => {
    if (this.selectedStoreIds.length === 0) {
      alert('선택된 스토어가 없습니다.');
      return;
    }
    const labelMap = {
      'auto': '자동 판별로 복구',
      'active_paid': '이용중·유료',
      'active_free': '이용중·무료',
      'stopped_cancelled': '정지·구독취소',
      'stopped_inactive': '정지·미활동'
    };
    const label = labelMap[status] || status;
    if (!window.confirm(`선택한 ${this.selectedStoreIds.length}개 스토어의 상태를 "${label}" (으)로 변경하시겠습니까?`)) {
      return;
    }
    if (!this.props.updateStoresManualStatus) {
      toast.error('updateStoresManualStatus 액션을 찾을 수 없습니다.');
      return;
    }
    let _this = this;
    let payload = {
      ids: this.selectedStoreIds.slice(),
      manualStatus: status === 'auto' ? null : status
    };
    this.props.updateStoresManualStatus(payload, function(res) {
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
        return;
      }
      toast.success(`${_this.selectedStoreIds.length}개 스토어 상태 변경 완료`);
      _this.clearSelection();
      _this.getList();
    });
  };

  // === 완전 삭제 모달 열기 (탈퇴 탭 전용) ===
  @action openPermanentDeleteModal = (store) => {
    if (!store) {
      toast.error('스토어 정보가 없습니다.');
      return;
    }
    if (!this.props.getStoreDataCounts) {
      toast.error('getStoreDataCounts 액션을 찾을 수 없습니다.');
      return;
    }
    // store_id 또는 withdrawal_id 중 하나라도 있어야 함
    const storeId = store._rawStoreId || store._id || null;
    const withdrawalId = store._withdrawal && store._withdrawal._id ? store._withdrawal._id : null;
    if (!storeId && !withdrawalId) {
      toast.error('store_id와 withdrawal_id가 모두 없습니다. 삭제할 수 없습니다.');
      return;
    }

    let _this = this;
    this.permanentDeleteModal.isOpen = true;
    this.permanentDeleteModal.isLoading = true;
    this.permanentDeleteModal.isDeleting = false;
    this.permanentDeleteModal.store = store;
    this.permanentDeleteModal.counts = [];
    this.permanentDeleteModal.selectedCollections = [];
    this.permanentDeleteModal.confirmName = '';

    let payload = {};
    if (storeId) payload.store_id = storeId;
    if (withdrawalId) payload.withdrawal_id = withdrawalId;

    this.props.getStoreDataCounts(payload, function(res) {
      _this.permanentDeleteModal.isLoading = false;
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
        _this.permanentDeleteModal.isOpen = false;
        return;
      }
      if (res instanceof Error) {
        toast.error(res.message);
        _this.permanentDeleteModal.isOpen = false;
        return;
      }
      // GraphQL Response 타입은 { data: {...} } 형태로 래핑됨
      const dataObj = (res && res.data) || res || {};
      const counts = (dataObj && dataObj.collections) || [];
      _this.permanentDeleteModal.counts = counts;
      // 기본적으로 모든 컬렉션 선택
      _this.permanentDeleteModal.selectedCollections = counts.map(c => c.collection);
    });
  };

  @action closePermanentDeleteModal = () => {
    if (this.permanentDeleteModal.isDeleting) return;
    this.permanentDeleteModal.isOpen = false;
    this.permanentDeleteModal.store = null;
    this.permanentDeleteModal.counts = [];
    this.permanentDeleteModal.selectedCollections = [];
    this.permanentDeleteModal.confirmName = '';
  };

  // === 알림톡 충전 모달 ===
  @action openMsgChargeModal = (store) => {
    this.msgChargeModal.isOpen = true;
    this.msgChargeModal.isSaving = false;
    this.msgChargeModal.store = store;
    this.msgChargeModal.messageType = 'KAKAO';
    this.msgChargeModal.chargeCount = '';
    this.msgChargeModal.chargeAmount = '';
    this.msgChargeModal.chargeCategory = 'event';
    this.msgChargeModal.memo = '';
  };
  @action closeMsgChargeModal = () => {
    if (this.msgChargeModal.isSaving) return;
    this.msgChargeModal.isOpen = false;
    this.msgChargeModal.store = null;
  };
  saveMsgCharge = async () => {
    const m = this.msgChargeModal;
    if (m.isSaving) return;
    if (!m.store || !m.store._id) { toast('스토어 정보가 없습니다.'); return; }
    const count = parseInt(String(m.chargeCount).replace(/[^\d]/g, ''), 10) || 0;
    if (!count || count <= 0) { toast('충전 건수를 입력해 주세요.'); return; }
    const amount = parseInt(String(m.chargeAmount).replace(/[^\d]/g, ''), 10) || 0;
    if (!m.memo || !m.memo.trim()) { toast('사유를 입력해 주세요.'); return; }

    const categoryLabel = ({
      bank_transfer: '통장입금',
      event:         '이벤트',
      apology:       '불편 사항 보상',
      compensation:  '서비스 보상',
      etc:           '기타'
    })[m.chargeCategory] || '기타';

    if (!window.confirm(`'${m.store.name}' 스토어에 알림톡 ${count.toLocaleString()}건을 충전합니다.\n구분: ${categoryLabel}\n금액: ${amount.toLocaleString()}원\n계속할까요?`)) return;

    m.isSaving = true;
    try {
      const reqPayload = {
        store_id: m.store._id,
        messageType: m.messageType,
        chargeCount: count,
        chargeAmount: amount,
        chargeCategory: m.chargeCategory,
        memo: m.memo
      };
      console.log('[adminChargeStoreMessages] req:', reqPayload);
      const res = await this.props.adminChargeStoreMessages(reqPayload);
      console.log('[adminChargeStoreMessages] res:', res);

      if (res && res.errors && res.errors.length > 0) {
        toast.error('충전 실패: ' + (res.errors[0].message || ''));
        return;
      }
      if (!res || !res.data) {
        toast.error('서버 응답이 비어 있습니다. (백엔드 배포 여부 확인)');
        return;
      }
      const quotaAfter = res.data && res.data.messageQuotaAfter != null
        ? ` · 현재 잔량 ${Number(res.data.messageQuotaAfter).toLocaleString()}건`
        : '';
      toast.success(`알림톡 ${count.toLocaleString()}건 충전 완료 (${categoryLabel})${quotaAfter}`);
      m.isOpen = false;
      m.store = null;
    } catch (e) {
      console.error('[adminChargeStoreMessages] error:', e);
      toast.error('충전 중 오류: ' + (e.message || ''));
    } finally {
      m.isSaving = false;
    }
  };

  // === 통장입금 처리 모달 ===
  @action openManualPayModal = (store) => {
    const today = moment().format('YYYY-MM-DD');
    const shops = (store && store.vr_shop) || [];
    const firstShop = shops[0] || null;
    const initialShopNo = firstShop ? firstShop.platformShopNo : 1;
    // 현재 샵의 useExpiryDate 가 미래면 거기서부터, 아니면 오늘부터
    const refExpiry = (firstShop && firstShop.useExpiryDate) || (store && store.useExpiryDate);
    const baseStart = (refExpiry && moment(refExpiry).isAfter(moment()))
      ? moment(refExpiry).format('YYYY-MM-DD')
      : today;
    const baseEnd = moment(baseStart).add(30, 'days').format('YYYY-MM-DD');
    this.manualPayModal.isOpen = true;
    this.manualPayModal.isSaving = false;
    this.manualPayModal.isSendingTaxInvoice = false;
    this.manualPayModal.taxInvoiceSent = false;
    this.manualPayModal.store = store;
    this.manualPayModal.shopNo = String(initialShopNo);
    this.manualPayModal.startDate = baseStart;
    this.manualPayModal.useExpiryDate = baseEnd;
    this.manualPayModal.totalAmount = '';
    this.manualPayModal.bankTransferReason = '';
    this.manualPayModal.taxInvoiceIssued = false;
    this.manualPayModal.taxInvoiceEmail = (store && (store.notificationEmail || store.email)) || '';
    this.manualPayModal.businessRegNumber = '';
  };

  // 시작일 기준 N개월 종료일 자동 설정
  @action setManualPayPeriod = (months) => {
    const m = this.manualPayModal;
    const start = m.startDate ? moment(m.startDate) : moment();
    if (!m.startDate) m.startDate = start.format('YYYY-MM-DD');
    m.useExpiryDate = start.clone().add(months, 'months').format('YYYY-MM-DD');
  };

  // 샵 변경 시 해당 샵의 useExpiryDate 기준으로 시작/종료일 재계산
  @action onChangeManualPayShop = (shopNoStr) => {
    const m = this.manualPayModal;
    m.shopNo = shopNoStr;
    const shops = (m.store && m.store.vr_shop) || [];
    const shop = shops.find(s => String(s.platformShopNo) === String(shopNoStr));
    const refExpiry = shop && shop.useExpiryDate;
    const baseStart = (refExpiry && moment(refExpiry).isAfter(moment()))
      ? moment(refExpiry).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
    m.startDate = baseStart;
    m.useExpiryDate = moment(baseStart).add(30, 'days').format('YYYY-MM-DD');
  };

  @action closeManualPayModal = () => {
    if (this.manualPayModal.isSaving) return;
    this.manualPayModal.isOpen = false;
    this.manualPayModal.store = null;
  };

  // 부가세/공급가액 자동 계산 (입금금액 / 11 = 부가세)
  calcVat = () => {
    const total = parseInt(String(this.manualPayModal.totalAmount).replace(/[^\d]/g, ''), 10) || 0;
    if (total <= 0) return {total: 0, vat: 0, supply: 0};
    const vat = Math.round(total / 11);
    const supply = total - vat;
    return {total, vat, supply};
  };

  sendTaxInvoiceRequest = async () => {
    const m = this.manualPayModal;
    if (m.isSendingTaxInvoice) return;
    if (!m.store || !m.store._id) { toast('스토어 정보가 없습니다.'); return; }
    if (!m.shopNo) { toast('샵을 선택해 주세요.'); return; }
    if (!m.taxInvoiceEmail) { toast('세금계산서 이메일을 입력해 주세요.'); return; }
    if (!m.businessRegNumber) { toast('사업자등록번호를 입력해 주세요.'); return; }
    const total = parseInt(String(m.totalAmount).replace(/[^\d]/g, ''), 10) || 0;
    if (!total || total <= 0) { toast('입금 금액을 입력해 주세요.'); return; }

    if (!window.confirm(`design@onnomads.com 으로 세금계산서 발행 요청 메일을 보냅니다.\n\n샵: Shop#${m.shopNo}\n수신 이메일: ${m.taxInvoiceEmail}\n사업자번호: ${m.businessRegNumber}\n금액: ${total.toLocaleString('ko-KR')}원\n\n계속할까요?`)) return;

    const calc = this.calcVat();
    m.isSendingTaxInvoice = true;
    try {
      const res = await this.props.sendTaxInvoiceRequest({
        store_id: m.store._id,
        shopNo: parseInt(m.shopNo, 10),
        totalAmount: total,
        vatAmount: calc.vat,
        supplyAmount: calc.supply,
        useExpiryDate: m.useExpiryDate || undefined,
        startDate: m.startDate || undefined,
        taxInvoiceEmail: m.taxInvoiceEmail,
        businessRegNumber: m.businessRegNumber,
        bankTransferReason: m.bankTransferReason || ''
      });
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message || '메일 발송 실패');
        return;
      }
      m.taxInvoiceSent = true;
      toast.success('세금계산서 발행 요청 메일이 design@onnomads.com 으로 발송되었습니다.');
    } catch (e) {
      console.error(e);
      toast.error('메일 발송 중 오류가 발생했습니다.');
    } finally {
      m.isSendingTaxInvoice = false;
    }
  };

  saveManualUseExpiry = async () => {
    const m = this.manualPayModal;
    if (m.isSaving) return;
    if (!m.store || !m.store._id) { toast('스토어 정보가 없습니다.'); return; }
    if (!m.shopNo) { toast('샵을 선택해 주세요.'); return; }
    if (!m.useExpiryDate) { toast('사용 종료일을 선택해 주세요.'); return; }
    const total = parseInt(String(m.totalAmount).replace(/[^\d]/g, ''), 10) || 0;
    if (!total || total <= 0) { toast('입금 금액을 입력해 주세요.'); return; }
    if (m.taxInvoiceIssued && !m.taxInvoiceEmail) { toast('세금계산서 이메일을 입력해 주세요.'); return; }
    if (m.taxInvoiceIssued && !m.businessRegNumber) { toast('사업자 등록번호를 입력해 주세요.'); return; }

    m.isSaving = true;
    try {
      const reqPayload = {
        store_id: m.store._id,
        shopNo: parseInt(m.shopNo, 10),
        useExpiryDate: m.useExpiryDate,
        startDate: m.startDate || undefined,
        totalAmount: total,
        bankTransferReason: m.bankTransferReason || '',
        taxInvoiceIssued: !!m.taxInvoiceIssued,
        taxInvoiceEmail: m.taxInvoiceEmail || '',
        businessRegNumber: m.businessRegNumber || ''
      };
      console.log('[setStoreManualUseExpiry] req:', reqPayload);
      const res = await this.props.setStoreManualUseExpiry(reqPayload);
      console.log('[setStoreManualUseExpiry] res:', res);

      if (res && res.errors && res.errors.length > 0) {
        toast.error('저장 실패: ' + (res.errors[0].message || '알 수 없는 오류'));
        return;
      }
      if (!res || !res.data) {
        toast.error('서버 응답이 비어 있습니다. (백엔드 배포 여부 확인)');
        return;
      }
      const d = res.data;
      const newExpiry = d.useExpiryDate ? moment(d.useExpiryDate).format('YYYY-MM-DD') : m.useExpiryDate;
      toast.success(`통장입금 처리 완료 — Shop#${d.shopNo || m.shopNo} 사용기간: ${newExpiry}`);
      m.isOpen = false;
      m.store = null;
      this.getList();
    } catch (e) {
      console.error('[setStoreManualUseExpiry] error:', e);
      toast.error('저장 중 오류: ' + (e.message || ''));
    } finally {
      m.isSaving = false;
    }
  };

  @action toggleDeleteCollection = (collection) => {
    let idx = this.permanentDeleteModal.selectedCollections.indexOf(collection);
    if (idx === -1) {
      this.permanentDeleteModal.selectedCollections.push(collection);
    } else {
      this.permanentDeleteModal.selectedCollections.splice(idx, 1);
    }
  };

  @action toggleDeleteAllCollections = () => {
    let all = this.permanentDeleteModal.counts.map(c => c.collection);
    if (this.permanentDeleteModal.selectedCollections.length === all.length) {
      this.permanentDeleteModal.selectedCollections = [];
    } else {
      this.permanentDeleteModal.selectedCollections = all;
    }
  };

  // 완전삭제 확인 입력값이 표시 이름과 정확히 일치하는지 검증
  isPermanentDeleteConfirmValid = () => {
    const m = this.permanentDeleteModal;
    if (!m.store) return false;
    const displayName = (m.store.name || (m.store._withdrawal && m.store._withdrawal.snapshotName) || '').trim();
    const inputName = (m.confirmName || '').trim();
    if (!inputName) return false;
    if (displayName) {
      return inputName === displayName;
    }
    // 이름이 없는 orphan 데이터: 'DELETE' 입력 요구
    return inputName === 'DELETE';
  };

  @action confirmPermanentDelete = () => {
    let m = this.permanentDeleteModal;
    if (!m.store) return;
    if (m.isDeleting) return;

    const storeId = m.store._rawStoreId || m.store._id || null;
    const withdrawalId = m.store._withdrawal && m.store._withdrawal._id ? m.store._withdrawal._id : null;
    if (!storeId && !withdrawalId) {
      toast.error('store_id와 withdrawal_id가 모두 없습니다.');
      return;
    }

    let displayName = (m.store.name || (m.store._withdrawal && m.store._withdrawal.snapshotName) || '').trim();
    let inputName = (m.confirmName || '').trim();

    // 이름이 있는 경우에만 검증 (orphan 데이터는 검증 우회)
    if (displayName) {
      if (!inputName) {
        alert('스토어명을 입력해주세요.');
        return;
      }
      if (inputName !== displayName) {
        alert(`스토어명이 일치하지 않습니다.\n입력: "${inputName}"\n실제: "${displayName}"`);
        return;
      }
    }
    else {
      // 이름조차 없는 경우, 사용자가 명시적으로 'DELETE'를 입력해야 함
      if (inputName !== 'DELETE') {
        alert('스토어명이 없는 데이터입니다. 삭제하려면 "DELETE" 를 정확히 입력해주세요.');
        return;
      }
    }

    if (m.selectedCollections.length === 0) {
      alert('삭제할 컬렉션을 1개 이상 선택해주세요.');
      return;
    }
    if (!window.confirm(`정말로 [${displayName || '(이름 없음)'}]의 ${m.selectedCollections.length}개 컬렉션 데이터를 영구 삭제하시겠습니까?\n\n이 작업은 되돌릴 수 없습니다.`)) {
      return;
    }

    let _this = this;
    let payload = {
      confirmName: inputName,
      collections: m.selectedCollections.slice()
    };
    if (storeId) payload.store_id = storeId;
    if (withdrawalId) payload.withdrawal_id = withdrawalId;

    this.permanentDeleteModal.isDeleting = true;
    this.props.permanentDeleteStore(payload, function(res) {
      _this.permanentDeleteModal.isDeleting = false;
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
        return;
      }
      if (res instanceof Error) {
        toast.error(res.message);
        return;
      }
      // GraphQL Response 타입은 { data: {...} } 형태로 래핑됨
      const dataObj = (res && res.data) || res || {};
      const totalDeleted = (dataObj && dataObj.totalDeleted) || 0;
      toast.success(`[${displayName || '(이름 없음)'}] 완전 삭제 완료 (총 ${totalDeleted}건)`);
      if (dataObj && dataObj.collections) {
        console.log('완전 삭제 결과:', dataObj.collections);
      }
      _this.closePermanentDeleteModal();
      _this.getList();
    });
  };

  // === 카페24 토큰 단건 갱신 ===
  // AOA.renewToken 액션은 콜백을 호출하지 않고 history.push('/')를 하는 버그가 있어
  // getStoreDetail({isRefreshToken: true})로 _checkCafe24Token을 호출해 토큰을 갱신함
  @action renewStoreToken = (store) => {
    if (!store || !store._id) return;
    if (this.renewingTokenIds.indexOf(store._id) !== -1) return;
    if (!this.props.getStoreDetail) {
      toast.error('getStoreDetail 액션을 찾을 수 없습니다.');
      return;
    }
    let _this = this;
    this.renewingTokenIds.push(store._id);
    let shopNo = (store.vr_shop && store.vr_shop[0] && store.vr_shop[0].platformShopNo) || 1;
    this.props.getStoreDetail({
      store_id: store._id,
      shopNo: shopNo,
      isRefreshToken: true
    }, function(res) {
      let idx = _this.renewingTokenIds.indexOf(store._id);
      if (idx !== -1) _this.renewingTokenIds.splice(idx, 1);

      if (res && res.errors && res.errors.length > 0) {
        toast.error(`[${store.name || store.platformId}] ${res.errors[0].message}`);
        return;
      }
      if (res instanceof Error) {
        toast.error(`[${store.name || store.platformId}] ${res.message}`);
        return;
      }
      toast.success(`[${store.name || store.platformId}] 토큰 갱신 완료`);
      _this.getList();
    });
  };

  // === 선택된 스토어 스킨 새로고침 (순차 처리) ===
  @action bulkRefreshSkins = async () => {
    if (this.bulkSkinRefresh.isRunning) return;
    if (!this.props.getApplySkins) {
      toast.error('getApplySkins 액션을 찾을 수 없습니다.');
      return;
    }
    if (this.selectedStoreIds.length === 0) {
      alert('새로고침할 스토어를 먼저 선택해주세요.');
      return;
    }
    // 현재 페이지 docs에서 선택된 스토어만 추출
    let allDocs = (this.list && this.list.docs) || [];
    let selectedSet = new Set(this.selectedStoreIds);
    let targetStores = allDocs.filter(s => selectedSet.has(s._id));
    if (targetStores.length === 0) {
      alert('선택된 스토어를 현재 페이지에서 찾을 수 없습니다.');
      return;
    }
    if (!window.confirm(`선택한 ${targetStores.length}개 스토어의 스킨을 순차적으로 새로고침합니다. 시간이 오래 걸릴 수 있습니다. 계속하시겠습니까?`)) {
      return;
    }

    let _this = this;
    this.bulkSkinRefresh.isRunning = true;
    this.bulkSkinRefresh.current = 0;
    this.bulkSkinRefresh.total = targetStores.length;
    this.bulkSkinRefresh.failed = 0;
    this.bulkSkinRefresh.cancelRequested = false;
    this.bulkSkinRefresh.currentStoreName = '';
    this.bulkSkinRefresh.failedStores = [];
    this.bulkSkinRefresh.showFailedModal = false;

    const callApi = (params) => new Promise((resolve) => {
      _this.props.getApplySkins(params, function(res) {
        resolve(res);
      });
    });

    // 카페24 토큰 갱신 (스토어별 1회)
    // getStoreDetail({isRefreshToken: true})은 백엔드의 _checkCafe24Token을 호출해 토큰 갱신
    // (renewToken 액션은 콜백을 호출하지 않고 history.push를 하는 버그가 있어 사용 불가)
    const refreshToken = (store_id, shopNo) => new Promise((resolve) => {
      if (!_this.props.getStoreDetail) { resolve(null); return; }
      // 타임아웃 안전망 (10초 후 강제 resolve)
      let resolved = false;
      const safetyTimer = setTimeout(() => {
        if (!resolved) {
          resolved = true;
          resolve(null);
        }
      }, 10000);
      _this.props.getStoreDetail({
        store_id: store_id,
        shopNo: shopNo || 1,
        isRefreshToken: true
      }, function(res) {
        if (!resolved) {
          resolved = true;
          clearTimeout(safetyTimer);
          resolve(res);
        }
      });
    });

    const extractErrorMessage = (res, err) => {
      if (err && err.message) return err.message;
      if (res && res.errors && res.errors.length > 0) {
        return res.errors.map(e => e.message || String(e)).join(', ');
      }
      if (res && res.message) return res.message;
      if (res && res.name && res.name === 'Error') return res.toString();
      if (res && res instanceof Error) return res.message;
      return '알 수 없는 오류';
    };

    for (let i = 0; i < targetStores.length; i++) {
      if (this.bulkSkinRefresh.cancelRequested) break;
      const store = targetStores[i];
      this.bulkSkinRefresh.currentStoreName = store.name || store.platformId || '';
      this.bulkSkinRefresh.current = i + 1;

      // 모든 샵에 대해 스킨 동기화 호출 (첫 샵 번호로 토큰 갱신 후 진행)
      const shops = (store.vr_shop && store.vr_shop.length > 0) ? store.vr_shop : [{ platformShopNo: 1 }];
      const firstShopNo = shops[0] ? (shops[0].platformShopNo || 1) : 1;

      // 1단계: 카페24 토큰 먼저 갱신 (만료된 토큰일 경우 getApplySkins가 실패하므로)
      try {
        await refreshToken(store._id, firstShopNo);
      } catch (e) {
        // 토큰 갱신 실패해도 계속 진행 (이미 정상이거나 갱신 불가능한 경우 getApplySkins에서 실패하면 별도 기록)
      }

      let storeFailed = false;
      let failureRecords = [];
      for (let j = 0; j < shops.length; j++) {
        if (this.bulkSkinRefresh.cancelRequested) break;
        const shopNo = shops[j].platformShopNo || 1;
        try {
          let res = await callApi({
            store_id: store._id,
            shopNo: shopNo,
            actSync: true
          });
          // 에러 응답 또는 Error 인스턴스 체크
          let isErr = false;
          let errMsg = '';
          if (!res) {
            isErr = true; errMsg = '응답 없음';
          }
          else if (res.errors && res.errors.length > 0) {
            isErr = true; errMsg = extractErrorMessage(res);
          }
          else if (res instanceof Error || (res.name === 'Error' && res.message)) {
            isErr = true; errMsg = extractErrorMessage(res);
          }
          if (isErr) {
            storeFailed = true;
            failureRecords.push({ shopNo: shopNo, message: errMsg });
          }
        } catch (e) {
          storeFailed = true;
          failureRecords.push({ shopNo: shopNo, message: extractErrorMessage(null, e) });
        }
      }
      if (storeFailed) {
        this.bulkSkinRefresh.failed += 1;
        this.bulkSkinRefresh.failedStores.push({
          _id: store._id,
          name: store.name || '',
          platformId: store.platformId || '',
          domain: store.domain || '',
          tokenStatus: this.getTokenStatus(store),
          shopFailures: failureRecords,
        });
      }
    }

    let cancelled = this.bulkSkinRefresh.cancelRequested;
    let processedCount = this.bulkSkinRefresh.current;
    let totalCount = this.bulkSkinRefresh.total;
    let failedCount = this.bulkSkinRefresh.failed;
    this.bulkSkinRefresh.isRunning = false;
    this.bulkSkinRefresh.cancelRequested = false;

    if (cancelled) {
      toast.warn(`중단됨 (${processedCount}/${totalCount} 처리, 실패 ${failedCount}건)`);
    }
    else if (failedCount > 0) {
      toast.warn(`완료: ${totalCount}건 중 ${failedCount}건 실패`);
    }
    else {
      toast.success(`선택한 ${totalCount}건 스킨 새로고침 완료`);
    }

    // 실패가 있으면 모달 자동 표시
    if (failedCount > 0) {
      this.bulkSkinRefresh.showFailedModal = true;
    }

    // 갱신된 activeSkinCount를 반영하기 위해 리스트 새로고침 (선택은 유지)
    this.getList();
  };

  @action closeFailedSkinsModal = () => {
    this.bulkSkinRefresh.showFailedModal = false;
  };

  @action cancelBulkRefreshSkins = () => {
    this.bulkSkinRefresh.cancelRequested = true;
  };

  @action openStoreDetail = (store) => {
    let _this = this;
    // shopList의 isAllTab 패턴: store 데이터를 store_id로 래핑
    _this.modals.storeDetailData = {
      ...store,
      store_id: store,
      inAppOrder_id: store.lastInAppOrder_id
    };
    _this.modals.shop = store.vr_shop || [];
    _this.modals.selectedShopNo = '';
    _this.modals.skins = store.vr_skin || [];
    _this.modals.skinShopNo = (store.vr_shop && store.vr_shop[0] && store.vr_shop[0].platformShopNo) || 1;
    _this.modals.isRefreshingSkins = false;
    _this.modals.withdrawalReason = '관리자 탈퇴 처리';
    _this.modals.isStoreDetail = true;

    let order_id = store.lastInAppOrder_id ? store.lastInAppOrder_id._id : null;
    let shopNo = store.shopNo || 1;

    let params = {
      store_id: store._id,
      order_id: order_id,
      shopNo: shopNo,
      isRefreshToken: true
    };
    if (this.props.getStoreDetail) {
      this.props.getStoreDetail(params, function(res) {
        if (res && res.errors && res.errors.length > 0) {
          toast(res.errors[0].message);
        }
        else if (res && res.data) {
          _this.modals.storeDetailData.detail = res.data;
          if (res.data.shop) _this.modals.shop = res.data.shop;
        }
      });
    }
  };

  @action refreshSkins = (actSync) => {
    let _this = this;
    let store = this.modals.storeDetailData.store_id;
    if (!store || !store._id) {
      toast.error('스토어 정보가 없습니다.');
      return;
    }
    if (this.modals.isRefreshingSkins) return;

    this.modals.isRefreshingSkins = true;
    let params = {
      store_id: store._id,
      shopNo: this.modals.skinShopNo || 1,
      actSync: !!actSync
    };
    if (this.props.getApplySkins) {
      this.props.getApplySkins(params, function(res) {
        _this.modals.isRefreshingSkins = false;
        if (res && res.errors && res.errors.length > 0) {
          toast.error(res.errors[0].message);
        }
        else if (res && res.data) {
          _this.modals.skins = res.data;
          if (actSync) {
            toast.success('스킨 목록이 업데이트되었습니다.');
          }
        }
      });
    }
    else {
      _this.modals.isRefreshingSkins = false;
    }
  };

  @action closeStoreDetail = () => {
    this.modals.isStoreDetail = false;
  };

  @action toggleSampleStore = (store, nextValue) => {
    if (!store || !store._id) return;
    if (!this.props.setStoreSample) {
      toast.error('setStoreSample 액션을 찾을 수 없습니다.');
      return;
    }
    let _this = this;
    this.props.setStoreSample({store_id: store._id, isSample: nextValue}, function(res) {
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
        return;
      }
      // 모달의 store와 리스트의 store 모두 즉시 동기화
      store.isSample = nextValue;
      const listItems = (_this.list && _this.list.docs) || [];
      const target = listItems.find(s => s && s._id === store._id);
      if (target) target.isSample = nextValue;
      toast.success(nextValue ? '샘플 스토어로 설정되었습니다.' : '샘플 스토어 설정이 해제되었습니다.');
    });
  };

  modalToggle = () => {
    this.modals.isStoreDetail = !this.modals.isStoreDetail;
  };

  unsubscribeUserAction = async () => {
    let _this = this;
    let shopNo = this.modals.selectedShopNo;
    if (!shopNo) {
      alert('구독취소할 멀티샵을 선택해 주세요.');
      return;
    }
    if (!window.confirm('구독취소 하시겠습니까?')) return;
    let store = this.modals.storeDetailData.store_id;
    let params = {
      store_id: store._id,
      shopNo: parseInt(shopNo, 10)
    };
    if (this.props.unsubscribeUser) {
      let res = await this.props.unsubscribeUser(params);
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
      }
      else {
        toast.success('구독취소 완료');
        _this.closeStoreDetail();
        _this.getList();
      }
    }
  };

  withdrawalAction = async () => {
    let store = this.modals.storeDetailData.store_id;
    let reason = (this.modals.withdrawalReason || '').trim();
    if (!reason) {
      alert('탈퇴 사유를 입력해주세요.');
      return;
    }
    if (!window.confirm(`회원탈퇴 하시겠습니까?\n사유: ${reason}`)) return;
    if (this.props.withdrawal) {
      let res = await this.props.withdrawal({ store_id: store._id, reason: reason });
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
      }
      else if (res instanceof Error) {
        toast.error(res.message);
      }
      else {
        toast.success('회원탈퇴 완료');
        this.closeStoreDetail();
        this.getList();
      }
    }
  };

  sendMailToAction = async (mailType) => {
    let storeData = this.modals.storeDetailData;
    if (this.props.sendMailTo) {
      let res = await this.props.sendMailTo({ store_id: storeData.store_id._id, mailType: mailType });
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
      }
      else {
        toast.success('메일 발송 완료');
      }
    }
  };

  csLogin = async (store) => {
    let params = {
      id: store._id,
      platformId: store.platformId,
      emailId: store.email
    };
    await this.props.csLogin(params);
    Storage.remove("shops");
    window.location.href = "/reviewList";
  };

  // 카페24 토큰 상태 판별
  getTokenStatus = (store) => {
    const now = moment();
    if (!store) return { label: '없음', color: '#94a3b8', bg: '#f1f5f9', icon: 'help-circle' };
    if (!store.cafe24Token) {
      return { label: '없음', color: '#94a3b8', bg: '#f1f5f9', icon: 'slash' };
    }
    if (store.isCafe24TokenErr) {
      return { label: '오류', color: '#dc2626', bg: '#fee2e2', icon: 'alert-octagon' };
    }
    if (store.cafe24TokenRefreshExpiresAt && moment(store.cafe24TokenRefreshExpiresAt).isBefore(now)) {
      return { label: '만료', color: '#dc2626', bg: '#fecaca', icon: 'x-circle' };
    }
    if (store.cafe24TokenExpiresAt && moment(store.cafe24TokenExpiresAt).isBefore(now)) {
      // Access 토큰만 만료되고 refresh가 살아있으면 갱신 가능
      return { label: '갱신필요', color: '#ca8a04', bg: '#fef9c3', icon: 'refresh-cw' };
    }
    return { label: '정상', color: '#16a34a', bg: '#dcfce7', icon: 'check-circle' };
  };

  renderTokenBadge = (store) => {
    const t = this.getTokenStatus(store);
    const isRenewing = store && store._id && this.renewingTokenIds.indexOf(store._id) !== -1;
    return (
      <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap'}}>
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          padding: '2px 8px',
          borderRadius: '10px',
          fontSize: '11px',
          fontWeight: '600',
          backgroundColor: t.bg,
          color: t.color
        }}>
          <FeatherIcon icon={t.icon} size="11"/>
          {t.label}
        </span>
        <button
          type="button"
          title="토큰 갱신"
          disabled={isRenewing}
          onClick={(e) => { e.stopPropagation(); this.renewStoreToken(store); }}
          style={{
            background: 'none',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
            padding: '2px 4px',
            cursor: isRenewing ? 'wait' : 'pointer',
            color: isRenewing ? '#94a3b8' : '#5664D2',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1
          }}
          onMouseEnter={(e) => { if (!isRenewing) e.currentTarget.style.backgroundColor = '#eef2ff'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <FeatherIcon
            icon="refresh-cw"
            size="11"
            style={{animation: isRenewing ? 'spin 1s linear infinite' : 'none'}}
          />
        </button>
      </div>
    );
  };

  getStatusBadge = (store) => {
    const baseStyle = {padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap'};
    const manualStyle = {...baseStyle, border: '1px dashed #5664D2'};

    // 0. manualStatus가 설정되어 있으면 우선 적용 (자동 판별 무시)
    if (store.manualStatus) {
      switch (store.manualStatus) {
        case 'active_paid':
          return <span style={{...manualStyle, backgroundColor: '#dcfce7', color: '#16a34a'}}>이용중·유료 (수동)</span>;
        case 'active_free':
          return <span style={{...manualStyle, backgroundColor: '#fef9c3', color: '#ca8a04'}}>이용중·무료 (수동)</span>;
        case 'stopped_cancelled':
          return <span style={{...manualStyle, backgroundColor: '#fecaca', color: '#dc2626'}}>정지·구독취소 (수동)</span>;
        case 'stopped_inactive':
          return <span style={{...manualStyle, backgroundColor: '#f1f5f9', color: '#64748b'}}>정지·미활동 (수동)</span>;
        default:
          break;
      }
    }

    // 자동 판별: deletedDate 있으면 앱삭제 (isDelApp 체크보다 우선)
    if (store.deletedDate) {
      return <span style={{...baseStyle, backgroundColor: '#fef2f2', color: '#7c2d12', border: '1px solid #fecaca'}}>앱삭제</span>;
    }

    // === 자동 판별 ===
    // 백엔드와 동일 기준 (7일 그레이스 기간)
    const graceDate = moment().subtract(7, 'days');
    const hasValidExpiry = store.useExpiryDate && moment(store.useExpiryDate).isSameOrAfter(graceDate);

    // 결제/주문 이력 (백엔드 stopped_cancelled 필터와 동일한 6가지 흔적 + useExpiryDate 존재)
    const hasOrderHistory =
      store.isUseFirstOrder === true ||
      store.isPaidUser === true ||
      !!store.lastInAppOrder_id ||
      (Array.isArray(store.inAppOrder_ids) && store.inAppOrder_ids.length > 0) ||
      (Array.isArray(store.paidShopNo) && store.paidShopNo.length > 0) ||
      store.useExpiryDate !== undefined;

    // 1. 앱 삭제 → 정지·미활동
    if (store.isDelApp) {
      return <span style={{...baseStyle, backgroundColor: '#fee2e2', color: '#dc2626'}}>정지·미활동</span>;
    }
    // 2. 무료 스토어 → 이용중·무료 (만료 체크 없음)
    if (store.isFreeStore) {
      return <span style={{...baseStyle, backgroundColor: '#fef9c3', color: '#ca8a04'}}>이용중·무료</span>;
    }
    // 3. 무료 아님 + 유효 만료일 → 이용중·유료
    if (hasValidExpiry) {
      return <span style={{...baseStyle, backgroundColor: '#dcfce7', color: '#16a34a'}}>이용중·유료</span>;
    }
    // 4. 무료 아님 + 결제/주문 흔적 있음 → 정지·구독취소
    if (hasOrderHistory) {
      return <span style={{...baseStyle, backgroundColor: '#fecaca', color: '#dc2626'}}>정지·구독취소</span>;
    }
    // 5. 결제/주문 흔적 전혀 없음 → 정지·미활동
    return <span style={{...baseStyle, backgroundColor: '#f1f5f9', color: '#64748b'}}>정지·미활동</span>;
  };

  getShopStatusBadge = (shop) => {
    if (!shop.useExpiryDate) return <span style={{fontSize: '11px', color: '#adb5bd'}}>-</span>;
    const isExpired = moment(shop.useExpiryDate).isBefore(moment());
    if (isExpired) return <span style={{padding: '2px 6px', borderRadius: '8px', fontSize: '10px', fontWeight: '600', backgroundColor: '#fee2e2', color: '#dc2626'}}>만료</span>;
    return <span style={{padding: '2px 6px', borderRadius: '8px', fontSize: '10px', fontWeight: '600', backgroundColor: '#dcfce7', color: '#16a34a'}}>이용중</span>;
  };

  render() {
    const docs = this.list.docs || [];

    return (
      <div style={{padding: '0px 16px 30px', position: 'relative'}}>
        <button
          type="button"
          onClick={() => window.history.back()}
          aria-label="닫기"
          title="닫기"
          style={{
            position: 'absolute', top: '8px', right: '16px', zIndex: 10,
            width: '32px', height: '32px', borderRadius: '50%',
            border: '1px solid #e9ecef', background: '#ffffff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', color: '#6c757d'
          }}>
          <FeatherIcon icon="x" size="18"/>
        </button>
        <PageTitle title="전체 스토어" subtitle="스토어 관리" className="mb-4"/>

        {/* 리뷰 부스터 애드온 — 기존 유료자 일괄 부여 (런칭 1회·멱등) */}
        <Card small className="mb-4" style={{background: '#F8F9FC'}}>
          <CardBody style={{padding: '14px 16px'}}>
            <div style={{display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap'}}>
              <div style={{fontWeight: 700, color: '#334155', display: 'flex', alignItems: 'center', gap: 6}}>
                <FeatherIcon icon="award" size="16"/> 리뷰 부스터 애드온 — 기존 유료자 일괄 부여
              </div>
              <span style={{fontSize: 12, color: '#94A3B8'}}>기준일 이전 가입 + 현재 유료 스토어에 권한 부여 (런칭 시 1회, 멱등)</span>
              <div style={{display: 'flex', gap: 8, alignItems: 'center', marginLeft: 'auto'}}>
                <span style={{fontSize: 13, color: '#475569'}}>기준일</span>
                <FormInput type="date" value={this.grandfatherCutoff}
                           onChange={e => this.grandfatherCutoff = e.target.value}
                           style={{width: 160}} />
                <Button theme="primary" disabled={this.grandfatherRunning} onClick={this.runGrandfather}>
                  {this.grandfatherRunning ? '실행 중…' : '일괄 부여 실행'}
                </Button>
              </div>
            </div>
            {this.grandfatherResult && (
              <div style={{marginTop: 10, fontSize: 13, padding: '8px 12px', borderRadius: 6,
                           background: this.grandfatherResult.ok ? '#E6F4EA' : '#FDECEA',
                           color: this.grandfatherResult.ok ? '#1E7E34' : '#B91C1C'}}>
                {this.grandfatherResult.ok
                  ? `✓ 완료 — 대상 ${this.grandfatherResult.matched}개 중 ${this.grandfatherResult.modified}개 신규 부여 (이미 부여된 건 제외)`
                  : `✗ 실패 — ${this.grandfatherResult.error || '오류'}`}
              </div>
            )}
          </CardBody>
        </Card>

        {/* 검색 + 필터 */}
        <Card small className="mb-4">
          <CardBody style={{padding: '16px'}}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap'}}>
              <form onSubmit={this.onSearch} style={{flex: 1, minWidth: '250px'}}>
                <InputGroup>
                  <FormInput name="keyword" placeholder="스토어명, 대표자명, platformId, 도메인, 이메일, 전화번호" defaultValue={this.listParams.searchParams.keyword || ''}/>
                  <InputGroupAddon type="append">
                    <Button type="submit" theme="primary">검색</Button>
                  </InputGroupAddon>
                </InputGroup>
              </form>
              <div style={{display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap'}}>
                <Button size="sm" theme={this.filter === 'all' ? 'primary' : 'secondary'} outline={this.filter !== 'all'} onClick={() => this.setFilter('all')}>전체</Button>
                <span style={{fontSize: '12px', color: '#16a34a', fontWeight: '600', marginLeft: '4px'}}>이용중</span>
                <ButtonGroup size="sm">
                  <Button theme={this.filter === 'active_paid' ? 'success' : 'secondary'} outline={this.filter !== 'active_paid'} onClick={() => this.setFilter('active_paid')}>유료</Button>
                  <Button theme={this.filter === 'active_free' ? 'success' : 'secondary'} outline={this.filter !== 'active_free'} onClick={() => this.setFilter('active_free')}>무료</Button>
                </ButtonGroup>
                <span style={{fontSize: '12px', color: '#dc2626', fontWeight: '600', marginLeft: '4px'}}>정지</span>
                <ButtonGroup size="sm">
                  <Button theme={this.filter === 'stopped_cancelled' ? 'danger' : 'secondary'} outline={this.filter !== 'stopped_cancelled'} onClick={() => this.setFilter('stopped_cancelled')}>구독취소</Button>
                  <Button theme={this.filter === 'stopped_inactive' ? 'danger' : 'secondary'} outline={this.filter !== 'stopped_inactive'} onClick={() => this.setFilter('stopped_inactive')}>미활동</Button>
                  <Button theme={this.filter === 'withdrawal' ? 'danger' : 'secondary'} outline={this.filter !== 'withdrawal'} onClick={() => this.setFilter('withdrawal')}>탈퇴</Button>
                </ButtonGroup>
                <Button size="sm" theme={this.filter === 'sample' ? 'info' : 'secondary'} outline={this.filter !== 'sample'} onClick={() => this.setFilter('sample')} style={{marginLeft: '8px'}}>샘플 스토어</Button>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* 결과 요약 + 일괄 액션 바 */}
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px'}}>
          <div style={{display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap'}}>
            <span style={{fontSize: '13px', color: '#495057'}}>
              검색결과 <strong style={{color: '#5664D2'}}>{this.list.totalDocs || 0}</strong>개
            </span>
            {this.selectedStoreIds.length > 0 && (
              <span style={{fontSize: '13px', color: '#5664D2', fontWeight: '600'}}>
                <FeatherIcon icon="check-square" size="14" style={{verticalAlign: 'middle', marginRight: '4px'}}/>
                {this.selectedStoreIds.length}개 선택됨
                <Button size="sm" theme="light" onClick={() => this.clearSelection()} style={{fontSize: '11px', padding: '2px 8px', marginLeft: '8px'}}>선택해제</Button>
              </span>
            )}
          </div>
          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
            <Button
              size="sm"
              theme="info"
              outline
              disabled={this.bulkSkinRefresh.isRunning || this.selectedStoreIds.length === 0}
              onClick={() => this.bulkRefreshSkins()}
              style={{fontSize: '12px'}}
            >
              <FeatherIcon
                icon="refresh-cw"
                size="12"
                style={{
                  verticalAlign: 'middle',
                  marginRight: '4px',
                  animation: this.bulkSkinRefresh.isRunning ? 'spin 1s linear infinite' : 'none'
                }}
              />
              {this.bulkSkinRefresh.isRunning
                ? `처리중... ${this.bulkSkinRefresh.current}/${this.bulkSkinRefresh.total}`
                : '선택 스킨 새로고침'}
            </Button>
            <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
            <div style={{position: 'relative'}}>
              <Button
                size="sm"
                theme={this.selectedStoreIds.length > 0 ? 'primary' : 'secondary'}
                disabled={this.selectedStoreIds.length === 0}
                onClick={() => { this.showStatusMenu = !this.showStatusMenu; }}
                style={{fontSize: '12px'}}
              >
                <FeatherIcon icon="edit-3" size="12" style={{verticalAlign: 'middle', marginRight: '4px'}}/>
                상태 변경 ▾
              </Button>
              {this.showStatusMenu && this.selectedStoreIds.length > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '100%',
                    marginTop: '4px',
                    backgroundColor: '#fff',
                    border: '1px solid #e9ecef',
                    borderRadius: '6px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    zIndex: 100,
                    minWidth: '200px',
                    overflow: 'hidden'
                  }}
                  onMouseLeave={() => { this.showStatusMenu = false; }}
                >
                  {[
                    {value: 'auto', label: '자동 판별로 복구', color: '#64748b', icon: 'rotate-ccw'},
                    {value: 'active_paid', label: '이용중·유료', color: '#16a34a', icon: 'circle'},
                    {value: 'active_free', label: '이용중·무료', color: '#ca8a04', icon: 'circle'},
                    {value: 'stopped_cancelled', label: '정지·구독취소', color: '#dc2626', icon: 'circle'},
                    {value: 'stopped_inactive', label: '정지·미활동', color: '#64748b', icon: 'circle'}
                  ].map(opt => (
                    <button
                      key={opt.value}
                      type="button"
                      onClick={() => this.bulkUpdateStatus(opt.value)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        width: '100%',
                        padding: '10px 14px',
                        background: 'none',
                        border: 'none',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '13px',
                        color: '#333',
                        borderBottom: '1px solid #f1f5f9'
                      }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8f9fc'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <FeatherIcon icon={opt.icon} size="12" style={{color: opt.color}}/>
                      {opt.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <span style={{fontSize: '12px', color: '#adb5bd'}}>
              {this.list.page || 1} / {this.list.totalPages || 1} 페이지
            </span>
          </div>
        </div>

        {/* 로딩 */}
        {this.isLoading ? (
          <div className="text-center" style={{padding: '60px 0'}}>
            <ColorRing visible={true} height="50" width="50" colors={['#5a6169','#5a6169','#5a6169','#5a6169','#5a6169']}/>
          </div>
        ) : (
          <>
            {/* 테이블 */}
            <Card small>
              <div style={{overflowX: 'auto'}}>
                <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '13px'}}>
                  <thead>
                    <tr style={{backgroundColor: '#f8f9fc', borderBottom: '2px solid #e9ecef'}}>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap', width: '40px'}}>
                        <input
                          type="checkbox"
                          checked={this.isAllSelected()}
                          onChange={() => this.toggleSelectAll()}
                          style={{cursor: 'pointer'}}
                        />
                      </th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>상태</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>스토어명</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>PlatformId</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>대표자</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>이메일</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>연락처</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>샵 수</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>활성 스킨</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>토큰</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>플랜</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>만료일</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>구독취소일</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>가입일</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600', whiteSpace: 'nowrap'}}>기능</th>
                    </tr>
                  </thead>
                  <tbody>
                    {docs.length === 0 ? (
                      <tr><td colSpan={15} style={{textAlign: 'center', padding: '40px', color: '#adb5bd'}}>데이터가 없습니다.</td></tr>
                    ) : docs.map((store, idx) => {
                      const shops = store.vr_shop || [];
                      const isOpen = this.toggledStores[store._id];
                      const order = store.lastInAppOrder_id;
                      const isSelected = this.selectedStoreIds.indexOf(store._id) !== -1;

                      return (
                        <React.Fragment key={store._rowKey || store._id || ('idx_' + idx)}>
                          <tr style={{borderBottom: '1px solid #f0f0f0', backgroundColor: isSelected ? '#eef2ff' : (idx % 2 === 0 ? '#fff' : '#fafbfc')}}>
                            <td style={{padding: '10px 12px', textAlign: 'center'}}>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                disabled={!store._id}
                                onChange={() => store._id && this.toggleSelect(store._id)}
                                style={{cursor: store._id ? 'pointer' : 'not-allowed'}}
                              />
                            </td>
                            <td style={{padding: '10px 12px'}}>{this.getStatusBadge(store)}</td>
                            <td style={{padding: '10px 12px', fontWeight: '500', color: '#333', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                              {store.name || '-'}
                              {store.domain && (
                                <a href={'https://' + store.domain} target="_blank" rel="noopener noreferrer" style={{marginLeft: '4px', color: '#adb5bd', verticalAlign: 'middle'}} title={store.domain}>
                                  <span className="material-icons" style={{fontSize: '14px', verticalAlign: 'middle'}}>open_in_new</span>
                                </a>
                              )}
                            </td>
                            <td style={{padding: '10px 12px', color: '#6c757d'}}>{store.platformId || '-'}</td>
                            <td style={{padding: '10px 12px', color: '#6c757d'}}>{store.presidentName || '-'}</td>
                            <td style={{padding: '10px 12px', color: '#6c757d', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{store.email || '-'}</td>
                            <td style={{padding: '10px 12px', color: '#6c757d', whiteSpace: 'nowrap'}}>{store.tel || '-'}</td>
                            <td style={{padding: '10px 12px', textAlign: 'center'}}>
                              <span
                                onClick={() => shops.length > 0 && this.toggleShopDetail(store._id)}
                                style={{cursor: shops.length > 0 ? 'pointer' : 'default', color: '#5664D2', fontWeight: '600', textDecoration: shops.length > 0 ? 'underline' : 'none'}}
                              >
                                {shops.length}
                              </span>
                            </td>
                            <td style={{padding: '10px 12px', textAlign: 'center'}}>
                              {(() => {
                                const count = typeof store.activeSkinCount === 'number'
                                  ? store.activeSkinCount
                                  : (Array.isArray(store.vr_skin) ? store.vr_skin.filter(s => s && s.isSetScript).length : 0);
                                return (
                                  <span style={{
                                    display: 'inline-block',
                                    minWidth: '24px',
                                    padding: '2px 8px',
                                    borderRadius: '10px',
                                    fontSize: '11px',
                                    fontWeight: '700',
                                    backgroundColor: count > 0 ? '#dcfce7' : '#f1f5f9',
                                    color: count > 0 ? '#16a34a' : '#94a3b8'
                                  }}>
                                    {count}
                                  </span>
                                );
                              })()}
                            </td>
                            <td style={{padding: '10px 12px', textAlign: 'center'}}>
                              {this.renderTokenBadge(store)}
                            </td>
                            <td style={{padding: '10px 12px', color: '#333', whiteSpace: 'nowrap'}}>
                              {order ? (
                                <div style={{display: 'flex', flexDirection: 'column', gap: '2px', lineHeight: '1.4'}}>
                                  <div style={{fontWeight: '500'}}>{order.plan || order.orderName || '-'}</div>
                                  <div style={{display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap'}}>
                                    {typeof order.orderAmount === 'number' && order.orderAmount > 0 && (
                                      <span style={{fontSize: '11px', color: '#16a34a', fontWeight: '600'}}>
                                        {order.orderAmount.toLocaleString()}원
                                      </span>
                                    )}
                                    {order.payType && (
                                      <span style={{padding: '1px 6px', borderRadius: '8px', fontSize: '10px', fontWeight: '600', backgroundColor: order.payType === 'free' ? '#fef9c3' : '#e0e7ff', color: order.payType === 'free' ? '#ca8a04' : '#4338ca'}}>
                                        {order.payType === 'free' ? '무료' : order.payType}
                                      </span>
                                    )}
                                    {order.automaticPayment && (
                                      <span style={{padding: '1px 6px', borderRadius: '8px', fontSize: '10px', fontWeight: '600', backgroundColor: order.automaticPayment === 'T' ? '#dcfce7' : '#f1f5f9', color: order.automaticPayment === 'T' ? '#16a34a' : '#64748b'}}>
                                        {order.automaticPayment === 'T' ? '자동결제' : '일시불'}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ) : '-'}
                            </td>
                            <td style={{padding: '10px 12px', whiteSpace: 'nowrap', color: store.useExpiryDate && moment(store.useExpiryDate).isBefore(moment()) ? '#dc2626' : '#6c757d'}}>
                              {store.useExpiryDate ? moment(store.useExpiryDate).format('YYYY-MM-DD') : '-'}
                            </td>
                            <td style={{padding: '10px 12px', whiteSpace: 'nowrap', color: '#dc2626'}}>
                              {(() => {
                                let cancelledAt = store._latestCancelledAt;
                                if (!cancelledAt && Array.isArray(store.vr_shop) && store.vr_shop.length > 0) {
                                  let maxTs = 0;
                                  store.vr_shop.forEach(sh => {
                                    if (sh && sh.cancelledAt) {
                                      let t = new Date(sh.cancelledAt).getTime();
                                      if (t > maxTs) maxTs = t;
                                    }
                                  });
                                  if (maxTs > 0) cancelledAt = new Date(maxTs);
                                }
                                return cancelledAt ? moment(cancelledAt).format('YYYY-MM-DD') : '-';
                              })()}
                            </td>
                            <td style={{padding: '10px 12px', color: '#adb5bd', whiteSpace: 'nowrap'}}>{store.createdAt ? moment(store.createdAt).format('YYYY-MM-DD') : '-'}</td>
                            <td style={{padding: '10px 12px', textAlign: 'center', whiteSpace: 'nowrap'}}>
                              <ButtonGroup size="sm">
                                <Button theme="info" style={{fontSize: '11px', padding: '2px 8px'}} onClick={() => this.openStoreDetail(store)}>상세</Button>
                                <Button theme="light" style={{fontSize: '11px', padding: '2px 8px'}} onClick={() => this.csLogin(store)}>login</Button>
                                <Button theme="success" style={{fontSize: '11px', padding: '2px 8px'}} title="통장입금 처리 + 사용기간 설정" onClick={() => this.openManualPayModal(store)}>통장입금</Button>
                                <Button theme="warning" style={{fontSize: '11px', padding: '2px 8px'}} title="알림톡 수동 충전" onClick={() => this.openMsgChargeModal(store)}>알림톡 충전</Button>
                                {this.filter === 'withdrawal' && (
                                  <Button theme="danger" style={{fontSize: '11px', padding: '2px 8px'}} onClick={() => this.openPermanentDeleteModal(store)}>완전삭제</Button>
                                )}
                              </ButtonGroup>
                            </td>
                          </tr>
                          {/* 샵 상세 토글 */}
                          {isOpen && shops.length > 0 && (
                            <tr>
                              <td colSpan={15} style={{padding: '0 12px 12px 40px', backgroundColor: '#f8f9fc'}}>
                                <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '12px', marginTop: '8px'}}>
                                  <thead>
                                    <tr style={{borderBottom: '1px solid #e2e8f0'}}>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>ShopNo</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>샵 이름</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>상태</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>주문타입</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>만료일</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>구독취소일</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>도메인</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>언어</th>
                                      <th style={{padding: '6px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600'}}>메모</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {shops.map(shop => (
                                      <tr key={shop._id} style={{borderBottom: '1px solid #edf2f7'}}>
                                        <td style={{padding: '6px 10px', color: '#5664D2', fontWeight: '600'}}>{shop.platformShopNo}</td>
                                        <td style={{padding: '6px 10px', color: '#333'}}>{shop.shopName || shop.languageName || '-'}</td>
                                        <td style={{padding: '6px 10px'}}>{this.getShopStatusBadge(shop)}</td>
                                        <td style={{padding: '6px 10px', color: '#6c757d'}}>{shop.orderType || '-'}</td>
                                        <td style={{padding: '6px 10px', whiteSpace: 'nowrap', color: shop.useExpiryDate && moment(shop.useExpiryDate).isBefore(moment()) ? '#dc2626' : '#6c757d'}}>
                                          {shop.useExpiryDate ? moment(shop.useExpiryDate).format('YYYY-MM-DD') : '-'}
                                        </td>
                                        <td style={{padding: '6px 10px', whiteSpace: 'nowrap', color: '#dc2626'}}>
                                          {shop.cancelledAt ? moment(shop.cancelledAt).format('YYYY-MM-DD') : '-'}
                                        </td>
                                        <td style={{padding: '6px 10px', color: '#6c757d', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{shop.primaryDomain || shop.domain || '-'}</td>
                                        <td style={{padding: '6px 10px', color: '#6c757d'}}>{shop.languageName || '-'}</td>
                                        <td style={{padding: '6px 10px', color: '#6c757d', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{shop.memo || '-'}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Card>

            {/* 페이지네이션 */}
            {this.list.totalPages > 1 && (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px', marginTop: '20px'}}>
                <Button size="sm" theme="light" disabled={!this.list.hasPrevPage} onClick={() => this.goPage(1)} style={{fontSize: '12px'}}>
                  <FeatherIcon icon="chevrons-left" size="14"/>
                </Button>
                <Button size="sm" theme="light" disabled={!this.list.hasPrevPage} onClick={() => this.goPage(this.list.page - 1)} style={{fontSize: '12px'}}>
                  <FeatherIcon icon="chevron-left" size="14"/>
                </Button>

                {(() => {
                  const pages = [];
                  const current = this.list.page || 1;
                  const total = this.list.totalPages || 1;
                  let start = Math.max(1, current - 4);
                  let end = Math.min(total, start + 9);
                  if (end - start < 9) start = Math.max(1, end - 9);

                  for (let i = start; i <= end; i++) {
                    pages.push(
                      <Button key={i} size="sm" theme={i === current ? 'primary' : 'light'} onClick={() => this.goPage(i)} style={{fontSize: '12px', minWidth: '32px'}}>
                        {i}
                      </Button>
                    );
                  }
                  return pages;
                })()}

                <Button size="sm" theme="light" disabled={!this.list.hasNextPage} onClick={() => this.goPage(this.list.page + 1)} style={{fontSize: '12px'}}>
                  <FeatherIcon icon="chevron-right" size="14"/>
                </Button>
                <Button size="sm" theme="light" disabled={!this.list.hasNextPage} onClick={() => this.goPage(this.list.totalPages)} style={{fontSize: '12px'}}>
                  <FeatherIcon icon="chevrons-right" size="14"/>
                </Button>
              </div>
            )}
          </>
        )}

        {/* 스킨 새로고침 실패 결과 모달 */}
        <Modal
          open={this.bulkSkinRefresh.showFailedModal}
          toggle={() => this.closeFailedSkinsModal()}
          centered={true}
          size="lg"
        >
          <ModalHeader style={{borderBottom: '1px solid #e9ecef', padding: '14px 20px'}}>
            <span style={{fontSize: '15px', fontWeight: '600', color: '#dc2626'}}>
              <FeatherIcon icon="alert-triangle" size="16" style={{verticalAlign: 'middle', marginRight: '6px'}}/>
              스킨 새로고침 실패 ({this.bulkSkinRefresh.failedStores.length}건)
            </span>
          </ModalHeader>
          <ModalBody style={{padding: '0', maxHeight: '70vh', overflowY: 'auto'}}>
            <div style={{padding: '12px 20px', backgroundColor: '#fef2f2', borderBottom: '1px solid #fecaca', fontSize: '12px', color: '#7f1d1d'}}>
              아래 스토어들의 스킨 새로고침 중 오류가 발생했습니다. 카페24 토큰 만료, 권한 부족, 네트워크 오류 등이 원인일 수 있습니다.
            </div>
            <div style={{padding: '0'}}>
              <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '12px'}}>
                <thead>
                  <tr style={{backgroundColor: '#f8f9fc', borderBottom: '2px solid #e9ecef'}}>
                    <th style={{padding: '8px 12px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px', width: '40px'}}>#</th>
                    <th style={{padding: '8px 12px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>스토어명</th>
                    <th style={{padding: '8px 12px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>PlatformId</th>
                    <th style={{padding: '8px 12px', textAlign: 'center', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>토큰 상태</th>
                    <th style={{padding: '8px 12px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>실패 상세 (샵 / 메시지)</th>
                  </tr>
                </thead>
                <tbody>
                  {this.bulkSkinRefresh.failedStores.length === 0 ? (
                    <tr><td colSpan={5} style={{padding: '20px', textAlign: 'center', color: '#adb5bd'}}>실패한 스토어가 없습니다.</td></tr>
                  ) : this.bulkSkinRefresh.failedStores.map((s, i) => {
                    const t = s.tokenStatus || { label: '-', color: '#94a3b8', bg: '#f1f5f9', icon: 'help-circle' };
                    return (
                      <tr key={s._id || i} style={{borderBottom: '1px solid #f0f0f0'}}>
                        <td style={{padding: '10px 12px', color: '#8898aa', fontWeight: '600'}}>{i + 1}</td>
                        <td style={{padding: '10px 12px', color: '#212529', fontWeight: '500', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                          {s.name || '-'}
                          {s.domain && (
                            <a href={'https://' + s.domain} target="_blank" rel="noopener noreferrer" style={{marginLeft: '4px', color: '#adb5bd'}}>
                              <FeatherIcon icon="external-link" size="11" style={{verticalAlign: 'middle'}}/>
                            </a>
                          )}
                        </td>
                        <td style={{padding: '10px 12px', color: '#6c757d'}}>{s.platformId || '-'}</td>
                        <td style={{padding: '10px 12px', textAlign: 'center'}}>
                          <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '2px 8px',
                            borderRadius: '10px',
                            fontSize: '11px',
                            fontWeight: '600',
                            backgroundColor: t.bg,
                            color: t.color,
                            whiteSpace: 'nowrap'
                          }}>
                            <FeatherIcon icon={t.icon} size="11"/>
                            {t.label}
                          </span>
                        </td>
                        <td style={{padding: '10px 12px', color: '#dc2626'}}>
                          {s.shopFailures && s.shopFailures.length > 0 ? (
                            <ul style={{margin: 0, paddingLeft: '16px', listStyle: 'disc'}}>
                              {s.shopFailures.map((f, j) => (
                                <li key={j} style={{marginBottom: '4px', wordBreak: 'break-word'}}>
                                  <strong style={{color: '#5664D2'}}>샵 #{f.shopNo}</strong>
                                  <span style={{margin: '0 6px', color: '#94a3b8'}}>—</span>
                                  <span>{f.message}</span>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <span style={{color: '#94a3b8'}}>알 수 없음</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{padding: '12px 20px', borderTop: '1px solid #e9ecef', textAlign: 'right', backgroundColor: '#fff'}}>
              <Button theme="secondary" outline onClick={() => this.closeFailedSkinsModal()}>
                닫기
              </Button>
            </div>
          </ModalBody>
        </Modal>

        {/* 완전삭제 모달 */}
        <Modal
          size="lg"
          open={this.permanentDeleteModal.isOpen}
          toggle={() => this.closePermanentDeleteModal()}
          centered={true}
        >
          <ModalHeader style={{borderBottom: '1px solid #e9ecef', padding: '14px 20px', backgroundColor: '#fef2f2'}}>
            <span style={{fontSize: '15px', fontWeight: '700', color: '#dc2626'}}>
              <FeatherIcon icon="alert-triangle" size="16" style={{verticalAlign: 'middle', marginRight: '6px'}}/>
              완전삭제 — {(this.permanentDeleteModal.store && (this.permanentDeleteModal.store.name || (this.permanentDeleteModal.store._withdrawal && this.permanentDeleteModal.store._withdrawal.snapshotName))) || '-'}
            </span>
          </ModalHeader>
          <ModalBody style={{padding: '0', maxHeight: '80vh', overflowY: 'auto'}}>
            <div style={{padding: '14px 20px', backgroundColor: '#fef2f2', borderBottom: '1px solid #fecaca', fontSize: '12px', color: '#7f1d1d'}}>
              <strong>⚠ 경고:</strong> 이 작업은 선택한 컬렉션의 데이터를 영구 삭제하며 되돌릴 수 없습니다.
              체크박스로 삭제할 컬렉션을 선택하고, 스토어명을 정확히 입력 후 진행하세요.
            </div>

            {this.permanentDeleteModal.isLoading ? (
              <div style={{padding: '40px', textAlign: 'center'}}>
                <ColorRing visible={true} height="40" width="40" colors={['#5a6169','#5a6169','#5a6169','#5a6169','#5a6169']}/>
                <div style={{marginTop: '8px', fontSize: '12px', color: '#6c757d'}}>컬렉션 데이터 카운트 중...</div>
              </div>
            ) : (
              <>
                <div style={{padding: '14px 20px', borderBottom: '1px solid #e9ecef'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                    <span style={{fontSize: '13px', fontWeight: '600', color: '#212529'}}>
                      삭제 대상 컬렉션 ({this.permanentDeleteModal.counts.length}개, 총 <span style={{color: '#dc2626'}}>{this.permanentDeleteModal.counts.reduce((s, c) => s + c.count, 0).toLocaleString()}</span>건)
                    </span>
                    <Button size="sm" theme="light" outline onClick={() => this.toggleDeleteAllCollections()}>
                      {this.permanentDeleteModal.selectedCollections.length === this.permanentDeleteModal.counts.length ? '전체 해제' : '전체 선택'}
                    </Button>
                  </div>

                  {this.permanentDeleteModal.counts.length === 0 ? (
                    <div style={{padding: '20px', textAlign: 'center', color: '#adb5bd', fontSize: '12px'}}>
                      삭제할 데이터가 없습니다.
                    </div>
                  ) : (
                    <div style={{maxHeight: '300px', overflowY: 'auto', border: '1px solid #e9ecef', borderRadius: '6px'}}>
                      <table style={{width: '100%', fontSize: '12px', borderCollapse: 'collapse'}}>
                        <thead>
                          <tr style={{backgroundColor: '#f8f9fc', borderBottom: '2px solid #e9ecef'}}>
                            <th style={{padding: '8px 12px', textAlign: 'center', width: '40px'}}>
                              <input
                                type="checkbox"
                                checked={this.permanentDeleteModal.counts.length > 0 && this.permanentDeleteModal.selectedCollections.length === this.permanentDeleteModal.counts.length}
                                onChange={() => this.toggleDeleteAllCollections()}
                                style={{cursor: 'pointer'}}
                              />
                            </th>
                            <th style={{padding: '8px 12px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>컬렉션</th>
                            <th style={{padding: '8px 12px', textAlign: 'right', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>레코드 수</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.permanentDeleteModal.counts.map((c, i) => {
                            const isSelected = this.permanentDeleteModal.selectedCollections.indexOf(c.collection) !== -1;
                            return (
                              <tr
                                key={c.collection}
                                style={{borderBottom: '1px solid #f0f0f0', backgroundColor: isSelected ? '#fef2f2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), cursor: 'pointer'}}
                                onClick={() => this.toggleDeleteCollection(c.collection)}
                              >
                                <td style={{padding: '8px 12px', textAlign: 'center'}}>
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => this.toggleDeleteCollection(c.collection)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{cursor: 'pointer'}}
                                  />
                                </td>
                                <td style={{padding: '8px 12px', color: '#212529', fontFamily: 'monospace'}}>
                                  {c.collection}
                                  {c.collection === 'store' && <span style={{marginLeft: '6px', fontSize: '10px', color: '#dc2626', fontWeight: '600'}}>(스토어 본체)</span>}
                                </td>
                                <td style={{padding: '8px 12px', textAlign: 'right', color: '#dc2626', fontWeight: '700'}}>
                                  {c.count.toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div style={{padding: '14px 20px', borderBottom: '1px solid #e9ecef'}}>
                  {(() => {
                    const m = this.permanentDeleteModal;
                    const displayName = (m.store && (m.store.name || (m.store._withdrawal && m.store._withdrawal.snapshotName))) || '';
                    const isValid = this.isPermanentDeleteConfirmValid();
                    const hasInput = !!(m.confirmName || '').trim();
                    const inputStyle = hasInput
                      ? (isValid
                          ? { borderColor: '#16a34a', boxShadow: '0 0 0 1px #16a34a' }
                          : { borderColor: '#dc2626', boxShadow: '0 0 0 1px #dc2626' })
                      : {};

                    if (displayName) {
                      return (
                        <>
                          <div style={{fontSize: '12px', color: '#6c757d', marginBottom: '6px'}}>
                            확인을 위해 스토어명을 정확히 입력해주세요:
                            <br/>
                            <strong style={{color: '#212529', fontSize: '13px'}}>{displayName}</strong>
                          </div>
                          <FormInput
                            placeholder="위 스토어명을 입력하세요"
                            value={m.confirmName}
                            onChange={e => { m.confirmName = e.target.value; }}
                            style={inputStyle}
                          />
                          {hasInput && !isValid && (
                            <div style={{fontSize: '11px', color: '#dc2626', marginTop: '4px'}}>
                              스토어명이 일치하지 않습니다.
                            </div>
                          )}
                          {hasInput && isValid && (
                            <div style={{fontSize: '11px', color: '#16a34a', marginTop: '4px'}}>
                              ✓ 일치합니다.
                            </div>
                          )}
                        </>
                      );
                    }
                    // 이름이 없는 orphan 데이터: DELETE 입력 요구
                    return (
                      <>
                        <div style={{fontSize: '12px', color: '#6c757d', marginBottom: '6px'}}>
                          스토어명 정보가 없는 데이터입니다. 삭제하려면 <strong style={{color: '#dc2626'}}>DELETE</strong> 를 정확히 입력해주세요:
                        </div>
                        <FormInput
                          placeholder='DELETE 를 입력하세요'
                          value={m.confirmName}
                          onChange={e => { m.confirmName = e.target.value; }}
                          style={inputStyle}
                        />
                        {hasInput && !isValid && (
                          <div style={{fontSize: '11px', color: '#dc2626', marginTop: '4px'}}>
                            DELETE 를 정확히 입력해주세요.
                          </div>
                        )}
                        {hasInput && isValid && (
                          <div style={{fontSize: '11px', color: '#16a34a', marginTop: '4px'}}>
                            ✓ 확인되었습니다.
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              </>
            )}

            <div style={{padding: '14px 20px', display: 'flex', justifyContent: 'flex-end', gap: '8px', backgroundColor: '#fff'}}>
              <Button theme="secondary" outline disabled={this.permanentDeleteModal.isDeleting} onClick={() => this.closePermanentDeleteModal()}>
                취소
              </Button>
              <Button
                theme="danger"
                disabled={
                  this.permanentDeleteModal.isLoading ||
                  this.permanentDeleteModal.isDeleting ||
                  this.permanentDeleteModal.selectedCollections.length === 0 ||
                  !this.isPermanentDeleteConfirmValid()
                }
                onClick={() => this.confirmPermanentDelete()}
              >
                {this.permanentDeleteModal.isDeleting ? (
                  <>
                    <FeatherIcon icon="loader" size="14" style={{verticalAlign: 'middle', marginRight: '4px', animation: 'spin 1s linear infinite'}}/>
                    삭제 중...
                  </>
                ) : (
                  <>
                    <FeatherIcon icon="trash-2" size="14" style={{verticalAlign: 'middle', marginRight: '4px'}}/>
                    완전삭제
                  </>
                )}
              </Button>
            </div>
          </ModalBody>
        </Modal>

        {/* 일괄 새로고침 진행 오버레이 */}
        {this.bulkSkinRefresh.isRunning && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999
          }}>
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '24px 32px',
              minWidth: '420px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
            }}>
              <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px'}}>
                <FeatherIcon icon="refresh-cw" size="18" style={{color: '#5664D2', animation: 'spin 1s linear infinite'}}/>
                <h5 style={{margin: 0, fontSize: '16px', fontWeight: '700', color: '#212529'}}>스킨 일괄 새로고침</h5>
              </div>
              <div style={{fontSize: '13px', color: '#6c757d', marginBottom: '12px'}}>
                <strong style={{color: '#5664D2'}}>{this.bulkSkinRefresh.current}</strong> / {this.bulkSkinRefresh.total}건 처리 중
                {this.bulkSkinRefresh.failed > 0 && (
                  <span style={{color: '#dc2626', marginLeft: '8px'}}>(실패 {this.bulkSkinRefresh.failed}건)</span>
                )}
              </div>
              <div style={{fontSize: '11px', color: '#94a3b8', marginBottom: '14px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                현재: {this.bulkSkinRefresh.currentStoreName || '-'}
              </div>
              {/* 프로그레스 바 */}
              <div style={{height: '8px', backgroundColor: '#f1f5f9', borderRadius: '4px', overflow: 'hidden', marginBottom: '14px'}}>
                <div style={{
                  height: '100%',
                  width: `${this.bulkSkinRefresh.total > 0 ? (this.bulkSkinRefresh.current / this.bulkSkinRefresh.total) * 100 : 0}%`,
                  backgroundColor: '#5664D2',
                  transition: 'width 0.3s'
                }}/>
              </div>
              <div style={{textAlign: 'right'}}>
                <Button size="sm" theme="danger" outline onClick={() => this.cancelBulkRefreshSkins()}>
                  중단
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* 모달 사이즈 확대 (shards-react 기본 lg = 800px → 1100px) */}
        <style>{`
          .modal-store-detail .modal-dialog { max-width: 1100px !important; }
        `}</style>

        {/* === 알림톡 충전 모달 === */}
        <Modal open={this.msgChargeModal.isOpen} toggle={() => {}} centered={true} size="md">
          <ModalHeader style={{padding: '14px 20px', borderBottom: '1px solid #e9ecef'}}>
            <span style={{fontSize: 15, fontWeight: 700}}>
              <FeatherIcon icon="message-circle" size="16" style={{verticalAlign: '-3px', marginRight: 6, color: '#F59E0B'}}/>
              알림톡 수동 충전
            </span>
            {this.msgChargeModal.store && (
              <div style={{fontSize: 12, color: '#6B7280', marginTop: 4}}>
                {this.msgChargeModal.store.name} · {this.msgChargeModal.store.platformId}
              </div>
            )}
          </ModalHeader>
          <ModalBody style={{padding: 20}}>
            {(() => {
              const m = this.msgChargeModal;
              const fieldStyle = {marginBottom: 14};
              const labelStyle = {display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6};
              const fmt = (n) => n ? new Intl.NumberFormat('ko-KR').format(n) : '0';
              const cnt = parseInt(String(m.chargeCount).replace(/[^\d]/g, ''), 10) || 0;
              const amt = parseInt(String(m.chargeAmount).replace(/[^\d]/g, ''), 10) || 0;
              const cats = [
                {key: 'bank_transfer', label: '통장입금',     color: '#10B981'},
                {key: 'event',         label: '이벤트',       color: '#4A6CF7'},
                {key: 'apology',       label: '불편 사항 보상', color: '#DC2626'},
                {key: 'compensation',  label: '서비스 보상',   color: '#7C3AED'},
                {key: 'etc',           label: '기타',         color: '#6B7280'}
              ];
              return (
                <>
                  <div style={fieldStyle}>
                    <label style={labelStyle}>구분 (충전 사유 카테고리)</label>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 6}}>
                      {cats.map(c => {
                        const active = m.chargeCategory === c.key;
                        return (
                          <button key={c.key}
                                  type="button"
                                  onClick={() => m.chargeCategory = c.key}
                                  style={{
                                    padding: '5px 12px',
                                    fontSize: 12,
                                    fontWeight: 600,
                                    borderRadius: 100,
                                    border: '1px solid ' + (active ? c.color : '#D1D5DB'),
                                    background: active ? c.color : '#FFFFFF',
                                    color: active ? '#FFFFFF' : '#374151',
                                    cursor: 'pointer',
                                    transition: 'all 150ms ease'
                                  }}>
                            {c.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div style={fieldStyle}>
                    <label style={labelStyle}>메시지 종류</label>
                    <FormSelect value={m.messageType}
                                onChange={(e) => m.messageType = e.target.value}>
                      <option value="KAKAO">카카오 알림톡</option>
                      <option value="SMS">SMS</option>
                    </FormSelect>
                  </div>

                  <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12}}>
                    <div style={fieldStyle}>
                      <label style={labelStyle}>* 충전 건수</label>
                      <FormInput type="text"
                                 placeholder="예: 100"
                                 value={m.chargeCount}
                                 onChange={(e) => m.chargeCount = e.target.value.replace(/[^\d]/g, '')}
                                 style={{textAlign: 'right', fontSize: 16, fontWeight: 700}}/>
                      {cnt > 0 && (
                        <div style={{marginTop: 4, fontSize: 11, color: '#10B981', fontWeight: 600}}>
                          + {fmt(cnt)} 건 충전 예정
                        </div>
                      )}
                    </div>
                    <div style={fieldStyle}>
                      <label style={labelStyle}>충전 금액 (옵션, KRW)</label>
                      <FormInput type="text"
                                 placeholder="0 (무상이면 비워두기)"
                                 value={m.chargeAmount}
                                 onChange={(e) => m.chargeAmount = e.target.value.replace(/[^\d]/g, '')}
                                 style={{textAlign: 'right', fontSize: 14}}/>
                      {amt > 0 && (
                        <div style={{marginTop: 4, fontSize: 11, color: '#4A6CF7', fontWeight: 600}}>
                          {fmt(amt)} 원
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={fieldStyle}>
                    <label style={labelStyle}>* 사유 / 메모</label>
                    <FormTextarea rows={3}
                                  placeholder="예: 9월 이벤트 참여 보상, 통장입금 결제건 처리, 서비스 장애 보상 등"
                                  value={m.memo}
                                  onChange={(e) => m.memo = e.target.value}/>
                    <p style={{margin: '6px 0 0', fontSize: 11, color: '#6B7280'}}>
                      이 내용은 충전 기록(MessageCharge)에 보관되며 운영 추적에 사용됩니다.
                    </p>
                  </div>

                  <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16, paddingTop: 14, borderTop: '1px solid #E5E7EB'}}>
                    <Button theme="light" onClick={this.closeMsgChargeModal} disabled={m.isSaving}>취소</Button>
                    <Button theme="warning" onClick={this.saveMsgCharge} disabled={m.isSaving}>
                      <FeatherIcon icon={m.isSaving ? 'loader' : 'plus-circle'} size="14" style={{verticalAlign: '-2px', marginRight: 4}}/>
                      {m.isSaving ? '충전 중…' : '충전 실행'}
                    </Button>
                  </div>
                </>
              );
            })()}
          </ModalBody>
        </Modal>

        {/* === 통장입금 처리 모달 === */}
        <Modal open={this.manualPayModal.isOpen} toggle={() => {}} centered={true} size="md">
          <ModalHeader style={{padding: '14px 20px', borderBottom: '1px solid #e9ecef'}}>
            <span style={{fontSize: 15, fontWeight: 700}}>통장입금 처리 · 사용기간 설정</span>
            {this.manualPayModal.store && (
              <div style={{fontSize: 12, color: '#6B7280', marginTop: 4}}>
                {this.manualPayModal.store.name} · {this.manualPayModal.store.platformId}
              </div>
            )}
          </ModalHeader>
          <ModalBody style={{padding: 20, maxHeight: '78vh', overflowY: 'auto'}}>
            {(() => {
              const m = this.manualPayModal;
              const calc = this.calcVat();
              const fmt = (n) => n ? new Intl.NumberFormat('ko-KR').format(n) : '0';
              const fieldStyle = {marginBottom: 14};
              const labelStyle = {display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6};
              const shops = (m.store && m.store.vr_shop) || [];
              const selectedShop = shops.find(s => String(s.platformShopNo) === String(m.shopNo));
              return (
                <>
                  {/* 샵 선택 */}
                  <div style={fieldStyle}>
                    <label style={labelStyle}>* 대상 샵</label>
                    {shops.length > 0 ? (
                      <FormSelect value={m.shopNo}
                                  onChange={(e) => this.onChangeManualPayShop(e.target.value)}>
                        {shops.map(s => (
                          <option key={s._id || s.platformShopNo} value={s.platformShopNo}>
                            {s.shopName || s.languageName || '샵'} (Shop#{s.platformShopNo})
                            {s.useExpiryDate ? ' · 만료 ' + moment(s.useExpiryDate).format('YYYY-MM-DD') : ''}
                          </option>
                        ))}
                      </FormSelect>
                    ) : (
                      <div style={{padding: '8px 12px', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 6, color: '#991B1B', fontSize: 12}}>
                        샵 정보가 없습니다. 샵 동기화 후 다시 시도해 주세요.
                      </div>
                    )}
                    {selectedShop && (
                      <div style={{marginTop: 6, fontSize: 11, color: '#6B7280'}}>
                        현재 만료일: <b style={{color: selectedShop.useExpiryDate && moment(selectedShop.useExpiryDate).isBefore(moment()) ? '#DC2626' : '#374151'}}>
                          {selectedShop.useExpiryDate ? moment(selectedShop.useExpiryDate).format('YYYY-MM-DD') : '-'}
                        </b>
                        {selectedShop.orderType ? <span style={{marginLeft: 8}}>· 결제유형: {selectedShop.orderType}</span> : null}
                      </div>
                    )}
                  </div>

                  <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12}}>
                    <div style={fieldStyle}>
                      <label style={labelStyle}>시작일</label>
                      <FormInput type="date" value={m.startDate}
                                 onChange={(e) => m.startDate = e.target.value}/>
                    </div>
                    <div style={fieldStyle}>
                      <label style={labelStyle}>* 사용 종료일</label>
                      <FormInput type="date" value={m.useExpiryDate}
                                 onChange={(e) => m.useExpiryDate = e.target.value}/>
                    </div>
                  </div>

                  {/* 빠른 기간 설정 — 시작일 기준 자동 종료일 */}
                  <div style={{marginTop: -4, marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'}}>
                    <span style={{fontSize: 11, color: '#6B7280'}}>빠른 기간:</span>
                    <div style={{display: 'inline-flex', gap: 6}}>
                      {[
                        {label: '1개월', months: 1},
                        {label: '3개월', months: 3},
                        {label: '6개월', months: 6},
                        {label: '1년',   months: 12}
                      ].map(p => {
                        const expected = m.startDate ? moment(m.startDate).add(p.months, 'months').format('YYYY-MM-DD') : '';
                        const isActive = !!(expected && m.useExpiryDate === expected);
                        return (
                          <button key={p.months}
                                  type="button"
                                  onClick={() => this.setManualPayPeriod(p.months)}
                                  style={{
                                    padding: '5px 12px',
                                    fontSize: 12,
                                    fontWeight: 600,
                                    borderRadius: 6,
                                    cursor: 'pointer',
                                    transition: 'all 150ms ease',
                                    border: isActive ? '1px solid #4A6CF7' : '1px solid #D1D5DB',
                                    background: isActive ? '#4A6CF7' : '#FFFFFF',
                                    color: isActive ? '#FFFFFF' : '#374151'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!isActive) {
                                      e.currentTarget.style.background = '#F3F4F6';
                                      e.currentTarget.style.borderColor = '#9CA3AF';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!isActive) {
                                      e.currentTarget.style.background = '#FFFFFF';
                                      e.currentTarget.style.borderColor = '#D1D5DB';
                                    }
                                  }}>
                            {p.label}
                          </button>
                        );
                      })}
                    </div>
                    {m.startDate && m.useExpiryDate && (
                      <span style={{fontSize: 11, color: '#6B7280', marginLeft: 4}}>
                        총 {moment(m.useExpiryDate).diff(moment(m.startDate), 'days')}일
                      </span>
                    )}
                  </div>

                  <div style={fieldStyle}>
                    <label style={labelStyle}>* 입금 금액 (부가세 포함, KRW)</label>
                    <FormInput type="text"
                               placeholder="예: 110000"
                               value={m.totalAmount}
                               onChange={(e) => { m.totalAmount = e.target.value.replace(/[^\d]/g, ''); }}
                               style={{textAlign: 'right', fontSize: 16, fontWeight: 600}}/>
                    {calc.total > 0 && (
                      <div style={{marginTop: 8, padding: '8px 12px', background: '#F0F7FF', border: '1px solid #BFDBFE', borderRadius: 6, fontSize: 12, color: '#1E40AF'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                          <span>공급가액</span><b>{fmt(calc.supply)}원</b>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                          <span>부가세 (자동)</span><b>{fmt(calc.vat)}원</b>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #BFDBFE', marginTop: 4, paddingTop: 4}}>
                          <span>합계</span><b>{fmt(calc.total)}원</b>
                        </div>
                      </div>
                    )}
                  </div>

                  <div style={fieldStyle}>
                    <label style={labelStyle}>사유 / 메모</label>
                    <FormTextarea rows={2}
                                  placeholder="예: 1개월 정기결제 통장입금"
                                  value={m.bankTransferReason}
                                  onChange={(e) => m.bankTransferReason = e.target.value}/>
                  </div>

                  <div style={{padding: 12, background: '#FAFAFA', border: '1px solid #E5E7EB', borderRadius: 8, marginBottom: 14}}>
                    <FormCheckbox checked={!!m.taxInvoiceIssued}
                                  onChange={() => m.taxInvoiceIssued = !m.taxInvoiceIssued}>
                      <b>세금계산서 발행 처리</b>
                    </FormCheckbox>
                    {m.taxInvoiceIssued && (
                      <>
                        <div style={{marginTop: 10, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10}}>
                          <div>
                            <label style={labelStyle}>세금계산서 이메일</label>
                            <FormInput type="email"
                                       placeholder="example@company.com"
                                       value={m.taxInvoiceEmail}
                                       onChange={(e) => m.taxInvoiceEmail = e.target.value}/>
                          </div>
                          <div>
                            <label style={labelStyle}>사업자 등록번호</label>
                            <FormInput type="text"
                                       placeholder="000-00-00000"
                                       value={m.businessRegNumber}
                                       onChange={(e) => m.businessRegNumber = e.target.value}/>
                          </div>
                        </div>
                        <div style={{marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', background: '#FFFBEB', border: '1px solid #FCD34D', borderRadius: 6}}>
                          <div style={{fontSize: 12, color: '#92400E'}}>
                            <b>온리플 세금계산서 관리자(design@onnomads.com)</b> 로 발행 요청 메일을 발송합니다.
                            {m.taxInvoiceSent && <span style={{marginLeft: 8, color: '#065F46', fontWeight: 700}}>✓ 발송됨</span>}
                          </div>
                          <Button theme={m.taxInvoiceSent ? 'success' : 'warning'}
                                  size="sm"
                                  onClick={this.sendTaxInvoiceRequest}
                                  disabled={m.isSendingTaxInvoice}>
                            {m.isSendingTaxInvoice ? '발송 중…' : (m.taxInvoiceSent ? '재발송' : '발행 요청')}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>

                  <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16}}>
                    <Button theme="light" onClick={this.closeManualPayModal} disabled={m.isSaving}>취소</Button>
                    <Button theme="primary" onClick={this.saveManualUseExpiry} disabled={m.isSaving}>
                      {m.isSaving ? '저장 중…' : '저장 (사용기간 적용)'}
                    </Button>
                  </div>
                </>
              );
            })()}
          </ModalBody>
        </Modal>

        {/* 스토어 상세 보기 모달 */}
        <Modal size="lg" className="modal-store-detail" open={this.modals.isStoreDetail} toggle={() => {}} centered={true}>
          <ModalHeader toggle={this.closeStoreDetail} style={{borderBottom: '1px solid #e9ecef', padding: '14px 20px'}}>
            <span style={{fontSize: '15px', fontWeight: '600', color: '#212529'}}>스토어 상세 보기</span>
          </ModalHeader>
          <ModalBody style={{padding: '0', backgroundColor: '#f8f9fc', maxHeight: '85vh', overflowY: 'auto'}}>
            {this.modals.storeDetailData && this.modals.storeDetailData.store_id ? (() => {
              const store = this.modals.storeDetailData.store_id;
              const order = this.modals.storeDetailData.lastInAppOrder_id;
              const detail = this.modals.storeDetailData.detail;
              const cardStyle = {backgroundColor: '#fff', borderRadius: '8px', padding: '16px 20px', marginBottom: '12px', border: '1px solid #e9ecef'};
              const sectionTitle = {fontSize: '11px', fontWeight: '700', color: '#5664D2', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px'};
              const labelStyle = {fontSize: '11px', color: '#8898aa', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '4px'};
              const valueStyle = {fontSize: '13px', color: '#212529', fontWeight: '500', wordBreak: 'break-all'};

              return (
                <div style={{padding: '16px 20px'}}>
                  {/* === 헤더: 스토어 기본 정보 === */}
                  <div style={cardStyle}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px', flexWrap: 'wrap'}}>
                      <div style={{flex: 1, minWidth: '250px'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px', flexWrap: 'wrap'}}>
                          <h5 style={{margin: 0, fontSize: '18px', fontWeight: '700', color: '#212529'}}>{store.name || '-'}</h5>
                          {this.getStatusBadge(store)}
                        </div>
                        <div style={{fontSize: '12px', color: '#6c757d'}}>
                          {store.presidentName || '대표자 미등록'} · {store.platformId}
                        </div>
                        {(store.domain || store.platformId) && (
                          <a
                            href={"https://" + (store.domain || store.platformId + ".cafe24.com")}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{fontSize: '12px', color: '#5664D2', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '4px'}}
                          >
                            <FeatherIcon icon="external-link" size="12"/>
                            {store.domain || store.platformId + ".cafe24.com"}
                          </a>
                        )}
                      </div>
                      <Button size="sm" theme="primary" onClick={() => this.csLogin(store)} style={{whiteSpace: 'nowrap'}}>
                        <FeatherIcon icon="log-in" size="14" style={{marginRight: '4px', verticalAlign: 'middle'}}/>
                        스토어 로그인
                      </Button>
                    </div>
                  </div>

                  {/* === 연락처 정보 === */}
                  <div style={cardStyle}>
                    <div style={sectionTitle}>
                      <FeatherIcon icon="user" size="12"/> 연락처 정보
                    </div>
                    <Row>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>이메일</div>
                        <div style={valueStyle}>{store.email || '-'}</div>
                      </Col>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>연락처</div>
                        <div style={valueStyle}>{store.tel || '-'}</div>
                      </Col>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>가입일</div>
                        <div style={valueStyle}>{store.createdAt ? moment(store.createdAt).format('YYYY-MM-DD') : '-'}</div>
                      </Col>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>최근 로그인</div>
                        <div style={valueStyle}>{store.lsatSigninAt ? moment(store.lsatSigninAt).format('YYYY-MM-DD') : '-'}</div>
                      </Col>
                    </Row>
                  </div>

                  {/* === 결제 / 플랜 정보 === */}
                  <div style={cardStyle}>
                    <div style={sectionTitle}>
                      <FeatherIcon icon="credit-card" size="12"/> 결제 정보
                    </div>
                    <Row>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>플랜</div>
                        <div style={valueStyle}>
                          {order ? (order.plan || order.orderName || '-') : '-'}
                        </div>
                      </Col>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>금액</div>
                        <div style={{...valueStyle, color: '#16a34a', fontWeight: '700'}}>
                          {order && typeof order.orderAmount === 'number' && order.orderAmount > 0
                            ? order.orderAmount.toLocaleString() + '원'
                            : '-'}
                        </div>
                      </Col>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>결제 타입</div>
                        <div>
                          {order && order.payType ? (
                            <Badge theme={order.payType === 'free' ? 'warning' : 'info'} style={{fontSize: '10px'}}>
                              {order.payType === 'free' ? '무료' : order.payType}
                            </Badge>
                          ) : <span style={valueStyle}>-</span>}
                          {order && order.automaticPayment && (
                            <Badge theme={order.automaticPayment === 'T' ? 'success' : 'secondary'} style={{fontSize: '10px', marginLeft: '4px'}}>
                              {order.automaticPayment === 'T' ? '자동결제' : '일시불'}
                            </Badge>
                          )}
                        </div>
                      </Col>
                      <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>만료일</div>
                        <div style={{...valueStyle, color: store.useExpiryDate && moment(store.useExpiryDate).isBefore(moment()) ? '#dc2626' : '#16a34a', fontWeight: '700'}}>
                          {store.useExpiryDate ? moment(store.useExpiryDate).format('YYYY-MM-DD') : '-'}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* === 어드민 설정 === */}
                  <div style={cardStyle}>
                    <div style={sectionTitle}>
                      <FeatherIcon icon="shield" size="12"/> 어드민 설정
                    </div>
                    <Row>
                      <Col xs="12" md="6" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>샘플 스토어</div>
                        <FormCheckbox
                          toggle small
                          checked={Boolean(store.isSample)}
                          onChange={() => this.toggleSampleStore(store, !store.isSample)}>
                          {store.isSample ? '샘플 스토어로 설정됨' : '일반 스토어'}
                        </FormCheckbox>
                        <p style={{fontSize: '11px', color: '#6c757d', marginTop: '4px', marginBottom: 0}}>
                          샘플 스토어로 표시되며, 통계/노출 등에서 제외될 수 있습니다.
                        </p>
                      </Col>
                    </Row>
                  </div>

                  {/* === 통계 === */}
                  {detail && (() => {
                    const total = detail.getMonthlySales || 0;
                    const sDate = detail.getMonthlySalesStartDate ? moment(detail.getMonthlySalesStartDate) : null;
                    const eDate = detail.getMonthlySalesEndDate ? moment(detail.getMonthlySalesEndDate) : null;
                    const monthsDiff = (sDate && eDate && eDate.isAfter(sDate))
                      ? Math.max(Math.round(eDate.diff(sDate, 'days') / 30), 1)
                      : 0;
                    const avgPerMonth = monthsDiff > 0 ? Math.ceil(total / monthsDiff) : 0;

                    // 월별 분기(서버에서 per-month 데이터 없을 때는 평균을 각 월에 균등 분배)
                    let monthBuckets = [];
                    if (Array.isArray(detail.monthlySales) && detail.monthlySales.length > 0) {
                      monthBuckets = detail.monthlySales.map(m => ({
                        label: moment(m.month || m.date).format('YYYY.MM'),
                        count: m.count || m.orderCount || 0,
                      }));
                    } else if (sDate && eDate && monthsDiff > 0) {
                      const base = sDate.clone().startOf('month');
                      for (let i = 0; i < monthsDiff; i++) {
                        monthBuckets.push({
                          label: base.clone().add(i, 'months').format('YYYY.MM'),
                          count: avgPerMonth,
                          estimated: true,
                        });
                      }
                    }
                    const maxCount = monthBuckets.reduce((m, b) => Math.max(m, b.count || 0), 0);

                    return (
                      <div style={cardStyle}>
                        <div style={sectionTitle}>
                          <FeatherIcon icon="bar-chart-2" size="12"/> 통계
                        </div>
                        <Row>
                          <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                            <div style={labelStyle}>리뷰 수</div>
                            <div style={{...valueStyle, fontSize: '18px', fontWeight: '700', color: '#5664D2'}}>
                              {(detail.reviewCount || 0).toLocaleString()}
                            </div>
                          </Col>
                          <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                            <div style={labelStyle}>상품 수</div>
                            <div style={{...valueStyle, fontSize: '18px', fontWeight: '700', color: '#5664D2'}}>
                              {(detail.productCount || 0).toLocaleString()}
                            </div>
                          </Col>
                          <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                            <div style={labelStyle}>월평균 주문수 {monthsDiff > 0 && <span style={{color: '#adb5bd', fontWeight: 400}}>({monthsDiff}개월)</span>}</div>
                            <div style={{...valueStyle, fontSize: '18px', fontWeight: '700', color: '#5664D2'}}>
                              {avgPerMonth.toLocaleString()}
                            </div>
                          </Col>
                          <Col xs="6" md="3" style={{marginBottom: '8px'}}>
                            <div style={labelStyle}>주문수 기간</div>
                            <div style={{...valueStyle, fontSize: '11px', color: '#6c757d'}}>
                              {detail.getMonthlySalesStartDate || '-'} ~<br/>
                              {detail.getMonthlySalesEndDate || '-'}
                            </div>
                          </Col>
                        </Row>

                        {/* 월별 주문수 차트 */}
                        {monthBuckets.length > 0 && (
                          <div style={{marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #f1f3f5'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                              <div style={{...labelStyle, marginBottom: 0}}>
                                월별 주문수
                                {monthBuckets.some(b => b.estimated) && (
                                  <span style={{marginLeft: '6px', color: '#adb5bd', fontWeight: 400, textTransform: 'none', letterSpacing: 0}}>
                                    (월평균 기준 분배 추정치)
                                  </span>
                                )}
                              </div>
                              <div style={{fontSize: '11px', color: '#6c757d'}}>
                                총 <strong style={{color: '#212529'}}>{total.toLocaleString()}</strong>건
                              </div>
                            </div>
                            <div style={{display: 'flex', alignItems: 'flex-end', gap: '6px', height: '80px', paddingBottom: '2px'}}>
                              {monthBuckets.map((b, idx) => {
                                const h = maxCount > 0 ? Math.max(Math.round((b.count / maxCount) * 68), 2) : 2;
                                return (
                                  <div key={idx} style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', minWidth: 0}}>
                                    <div style={{fontSize: '10px', color: '#212529', fontWeight: 600, whiteSpace: 'nowrap'}}>
                                      {(b.count || 0).toLocaleString()}
                                    </div>
                                    <div
                                      title={`${b.label}: ${(b.count || 0).toLocaleString()}건${b.estimated ? ' (추정)' : ''}`}
                                      style={{
                                        width: '100%',
                                        height: h + 'px',
                                        background: b.estimated ? 'repeating-linear-gradient(45deg, #c7cbe8, #c7cbe8 4px, #d8dcf0 4px, #d8dcf0 8px)' : 'linear-gradient(180deg, #5664D2, #7B86DE)',
                                        borderRadius: '3px 3px 0 0',
                                      }}
                                    />
                                    <div style={{fontSize: '10px', color: '#8898aa', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%'}}>
                                      {b.label}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  {/* === 활성 스킨 목록 === */}
                  {(() => {
                    const skins = this.modals.skins || [];
                    const activeSkinCount = skins.filter(s => s.isSetScript).length;
                    return (
                      <div style={cardStyle}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
                          <div style={{...sectionTitle, marginBottom: 0}}>
                            <FeatherIcon icon="layers" size="12"/>
                            활성 스킨 ({activeSkinCount}/{skins.length})
                          </div>
                          <div style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                            {this.modals.shop && this.modals.shop.length > 1 && (
                              <FormSelect
                                size="sm"
                                value={this.modals.skinShopNo}
                                onChange={e => { this.modals.skinShopNo = parseInt(e.target.value, 10); }}
                                style={{width: 'auto', fontSize: '11px'}}
                              >
                                {this.modals.shop.map((s, i) => (
                                  <option key={i} value={s.platformShopNo}>
                                    #{s.platformShopNo} {s.shopName || s.languageName || ''}
                                  </option>
                                ))}
                              </FormSelect>
                            )}
                            <Button
                              size="sm"
                              theme="primary"
                              outline
                              disabled={this.modals.isRefreshingSkins}
                              onClick={() => this.refreshSkins(true)}
                              style={{fontSize: '11px', padding: '4px 10px'}}
                            >
                              <FeatherIcon
                                icon="refresh-cw"
                                size="12"
                                style={{
                                  marginRight: '4px',
                                  verticalAlign: 'middle',
                                  animation: this.modals.isRefreshingSkins ? 'spin 1s linear infinite' : 'none'
                                }}
                              />
                              {this.modals.isRefreshingSkins ? '동기화 중...' : '스킨 목록 새로고침'}
                            </Button>
                          </div>
                        </div>
                        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                        {skins.length > 0 ? (
                          <div style={{overflowX: 'auto', margin: '0 -4px'}}>
                            <table style={{width: '100%', fontSize: '12px', borderCollapse: 'collapse'}}>
                              <thead>
                                <tr style={{borderBottom: '2px solid #e9ecef', backgroundColor: '#f8f9fc'}}>
                                  <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>샵#</th>
                                  <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>스킨명</th>
                                  <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>타입</th>
                                  <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>편집기</th>
                                  <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>언어</th>
                                  <th style={{padding: '8px 10px', textAlign: 'center', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>스크립트</th>
                                  <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>적용일</th>
                                </tr>
                              </thead>
                              <tbody>
                                {skins.map((skin, i) => (
                                  <tr key={i} style={{borderBottom: '1px solid #f0f0f0'}}>
                                    <td style={{padding: '8px 10px', color: '#5664D2', fontWeight: '700'}}>#{skin.shopNo || 1}</td>
                                    <td style={{padding: '8px 10px', color: '#212529', fontWeight: '500'}}>
                                      {skin.skin_thumbnail_url && (
                                        <img src={skin.skin_thumbnail_url} alt="" style={{width: '28px', height: '28px', borderRadius: '4px', verticalAlign: 'middle', marginRight: '6px', border: '1px solid #e9ecef', objectFit: 'cover'}}/>
                                      )}
                                      {skin.skin_name || '-'}
                                      <span style={{marginLeft: '6px', color: '#adb5bd', fontSize: '10px'}}>#{skin.skin_no}</span>
                                    </td>
                                    <td style={{padding: '8px 10px'}}>
                                      <Badge theme="info" outline style={{fontSize: '10px'}}>{skin.usage_type || '-'}</Badge>
                                    </td>
                                    <td style={{padding: '8px 10px', color: '#6c757d'}}>{skin.editor_type || '-'}</td>
                                    <td style={{padding: '8px 10px', color: '#6c757d'}}>{skin.language_code || '-'}</td>
                                    <td style={{padding: '8px 10px', textAlign: 'center'}}>
                                      {skin.isSetScript ? (
                                        <Badge theme="success" style={{fontSize: '10px'}}>적용</Badge>
                                      ) : (
                                        <Badge theme="secondary" style={{fontSize: '10px'}}>미적용</Badge>
                                      )}
                                    </td>
                                    <td style={{padding: '8px 10px', color: '#6c757d', whiteSpace: 'nowrap'}}>
                                      {skin.updatedAt ? moment(skin.updatedAt).format('YYYY-MM-DD') : '-'}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div style={{textAlign: 'center', padding: '20px', color: '#adb5bd', fontSize: '12px'}}>
                            활성화된 스킨이 없습니다. <strong>스킨 목록 새로고침</strong> 버튼을 눌러 동기화해주세요.
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  {/* === 샵 목록 === */}
                  {this.modals.shop && this.modals.shop.length > 0 && (
                    <div style={cardStyle}>
                      <div style={sectionTitle}>
                        <FeatherIcon icon="shopping-bag" size="12"/> 샵 목록 ({this.modals.shop.length})
                      </div>
                      <div style={{overflowX: 'auto', margin: '0 -4px'}}>
                        <table style={{width: '100%', fontSize: '12px', borderCollapse: 'collapse'}}>
                          <thead>
                            <tr style={{borderBottom: '2px solid #e9ecef', backgroundColor: '#f8f9fc'}}>
                              <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>샵#</th>
                              <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>이름</th>
                              <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>도메인</th>
                              <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>만료일</th>
                              <th style={{padding: '8px 10px', textAlign: 'left', color: '#8898aa', fontWeight: '600', fontSize: '11px'}}>구독취소일</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.modals.shop.map((s, i) => (
                              <tr key={i} style={{borderBottom: '1px solid #f0f0f0'}}>
                                <td style={{padding: '8px 10px', color: '#5664D2', fontWeight: '700'}}>#{s.platformShopNo}</td>
                                <td style={{padding: '8px 10px', color: '#212529', fontWeight: '500'}}>{s.shopName || s.languageName || '-'}</td>
                                <td style={{padding: '8px 10px', color: '#6c757d', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                  {s.primaryDomain || s.baseDomain || s.domain || '-'}
                                </td>
                                <td style={{padding: '8px 10px', color: s.useExpiryDate && moment(s.useExpiryDate).isBefore(moment()) ? '#dc2626' : '#6c757d', whiteSpace: 'nowrap'}}>
                                  {s.useExpiryDate ? moment(s.useExpiryDate).format('YYYY-MM-DD') : '-'}
                                </td>
                                <td style={{padding: '8px 10px', color: '#dc2626', fontWeight: '500', whiteSpace: 'nowrap'}}>
                                  {s.cancelledAt ? moment(s.cancelledAt).format('YYYY-MM-DD') : '-'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* === 위험 작업 === */}
                  <div style={{...cardStyle, borderColor: '#fecaca', backgroundColor: '#fef2f2'}}>
                    <div style={{...sectionTitle, color: '#dc2626'}}>
                      <FeatherIcon icon="alert-triangle" size="12"/> 위험 작업
                    </div>
                    <Row>
                      <Col xs="12" md="6" style={{marginBottom: '10px'}}>
                        <div style={labelStyle}>구독취소</div>
                        <div style={{display: 'flex', gap: '6px', alignItems: 'center', marginTop: '4px'}}>
                          <FormSelect
                            size="sm"
                            value={this.modals.selectedShopNo}
                            onChange={e => { this.modals.selectedShopNo = e.target.value; }}
                            style={{flex: 1}}
                          >
                            <option value="">샵 선택</option>
                            {this.modals.shop && this.modals.shop.map((item, i) => (
                              <option key={i} value={item.platformShopNo}>
                                #{item.platformShopNo} {item.shopName || item.languageName || ''}
                              </option>
                            ))}
                          </FormSelect>
                          <Button size="sm" theme="danger" onClick={() => this.unsubscribeUserAction()} style={{whiteSpace: 'nowrap'}}>
                            구독취소
                          </Button>
                        </div>
                      </Col>
                      <Col xs="12" md="6" style={{marginBottom: '10px'}}>
                        <div style={labelStyle}>회원탈퇴</div>
                        <div style={{display: 'flex', gap: '6px', alignItems: 'center', marginTop: '4px'}}>
                          <FormInput
                            size="sm"
                            placeholder="탈퇴 사유"
                            value={this.modals.withdrawalReason}
                            onChange={e => { this.modals.withdrawalReason = e.target.value; }}
                            style={{flex: 1}}
                          />
                          <Button size="sm" theme="danger" outline onClick={() => this.withdrawalAction()} style={{whiteSpace: 'nowrap'}}>
                            <FeatherIcon icon="user-x" size="14" style={{marginRight: '4px', verticalAlign: 'middle'}}/>
                            탈퇴 처리
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* === 빠른 기능 (메일 발송) === */}
                  <div style={cardStyle}>
                    <div style={sectionTitle}>
                      <FeatherIcon icon="mail" size="12"/> 메일 발송
                    </div>
                    <ButtonGroup size="sm">
                      <Button theme="warning" outline onClick={() => this.sendMailToAction('noPaied')}>미결제 메일</Button>
                      <Button theme="info" outline onClick={() => this.sendMailToAction('noPeriod')}>기간 메일</Button>
                      <Button theme="success" outline onClick={() => this.sendMailToAction('planUpgrade')}>업그레이드 메일</Button>
                      <Button theme="warning" outline onClick={() => this.sendMailToAction('planDowngrade')}>다운그레이드 메일</Button>
                    </ButtonGroup>
                  </div>

                  {/* === 시스템 ID === */}
                  <div style={{...cardStyle, backgroundColor: '#f8f9fc'}}>
                    <div style={sectionTitle}>
                      <FeatherIcon icon="hash" size="12"/> 시스템 ID
                    </div>
                    <Row>
                      <Col xs="12" md="6" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>스토어 ID</div>
                        <div style={{...valueStyle, fontFamily: 'monospace', fontSize: '11px', color: '#6c757d'}}>{store._id}</div>
                      </Col>
                      <Col xs="12" md="6" style={{marginBottom: '8px'}}>
                        <div style={labelStyle}>결제 ID</div>
                        <div style={{...valueStyle, fontFamily: 'monospace', fontSize: '11px', color: '#6c757d'}}>
                          {order ? order._id : '-'}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              );
            })() : (
              <div style={{padding: '60px 20px', textAlign: 'center', color: '#adb5bd'}}>
                데이터를 불러오는 중...
              </div>
            )}

            <div style={{padding: '12px 20px', backgroundColor: '#fff', borderTop: '1px solid #e9ecef', textAlign: 'right'}}>
              <Button theme="secondary" outline onClick={() => this.closeStoreDetail()}>
                닫기
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default AllStoreList;
